import React, { useState, useEffect, useRef } from "react";
import {
  Col,
  FormGroup,
  Input,
  Row,
  ModalFooter,
  ModalBody,
  ModalHeader,
  Modal,
  Container,
} from "reactstrap";
import { Image, Btn } from "../../AbstractElements";
import DataTable from "react-data-table-component";
import Form from "react-bootstrap/Form";
import {
  Button,
  OverlayTrigger,
  Popover,
  Spinner,
  Table,
} from "react-bootstrap";
import { AiOutlinePlus } from "react-icons/ai";
import ReactSelect from "react-select";
import makeAnimated from "react-select/animated";
import "./dashboardpos.css";
import axios from "../../axios/axios";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { FiTrash, FiShoppingCart } from "react-icons/fi";
import { FaPrint, FaSave, FaWhatsapp } from "react-icons/fa";
import { MdContactPhone, MdCreateNewFolder, MdDrafts } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin7Fill } from "react-icons/ri";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./dashboardpos.css";

// Import Redux actions
import {
  addDraftItem,
  removeDraftItem,
  clearAllDrafts
} from "../../utils/draftSlice";
import { toggleModal, closeModal } from "../../utils/modalSlice";

// Import POS Redux actions
import {
  setCart,
  addToCart,
  updateCartItem,
  removeFromCart,
  clearCart as clearCartAction,
  setSelectedUnits,
  updateSelectedUnit,
  setContactDetails,
  setAddressDetails,
  setAddCustomerDetails,
  setSelectedCompany,
  setSelectedBranch,
  setSearchQuery,
  setSearchBarcode,
  setShowBillingModal,
  setShowShippingModal,
  setIsInvoiceSaved,
  setInvoiceDetails,
  setSelectedCategory,
  setSelectedMaincategory,
  setCategorySearchQuery,
  setSubTArray,
  setShowQtyRed,
  setSaveBtn,
  setPrintBtn,
  setWhatsappBtn,
  resetForNewInvoice,
  resetPosState
} from "../../utils/posSlice";

import moment from "moment";
import { IoIosAddCircle } from "react-icons/io";
import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const Dashboardpos = () => {
  const baseurl = useSelector((store) => store.baseUrl);
  const AUTHORIZE_KEY = "c34FxCQy4DCGCHA9zlTgqTsywZJSW8hy";

  // Get POS state from Redux
  const posState = useSelector((state) => state.pos);
  const {
    cart,
    selectedUnits,
    contactId: contact_id,
    contactName: contact_name,
    contactNumber: contact_number,
    billingAddressId: Billingaddress_id,
    shippingAddressId: Shippingaddress_id,
    sameAsBilling,
    addCustomerDetails,
    selectedCompany,
    selectedBranch,
    searchQuery,
    searchBarcode,
    showBillingModal,
    showShippingModal,
    isInvoiceSaved,
    invoiceNo: Invoice_no,
    invoiceFullNo: Invoice_fullno,
    selectedCategory,
    selectedMaincategory,
    categorySearchQuery,
    subTArray,
    showQtyRed,
    saveBtn: Savebtn,
    printBtn: Printbtn,
    whatsappBtn: whatsappbtn,
  } = posState;

  // Get drafts from Redux
  const { draftItems: drafts, count: draftsCount } = useSelector((state) => state.drafts);
  const { isOpen } = useSelector((store) => store.modaldraft);

  const [firstAPICallMade, setFirstAPICallMade] = useState(false);
  const dispatch = useDispatch();

  // navbar
  const [showMore, setShowMore] = useState(false);
  const [isCategoryPanelOpen, setIsCategoryPanelOpen] = useState(false);

  const handleMoreClick = () => {
    setShowMore(!showMore);
    dispatch(setSelectedMaincategory("More"));
  };

  const {
    register,
    setValue,
    handleSubmit,
    reset,
  } = useForm();

  // attribute
  const [showattrmodal, setShowattrmodal] = useState(false);
  const [productImage, setProductImage] = useState("");
  const [product_selectid, setProductselectid] = useState("");
  const [selected_prod_index, setSelectedprodindex] = useState(null);
  const [attr_array, setAttrarray] = useState([]);
  const [json, setJson] = useState({});
  const [json_name, setJsonName] = useState({});

  // new pricelistwise
  const [attr_label, setAttrlabel] = useState([]);
  const [pricelist_array, setPricelistaarray] = useState([]);

  const [AttrProductname, setAttrProductname] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);

  const image_url_logo = localStorage.getItem("company_logo_pos");

  const generatePDF = async () => {
    window.html2canvas = html2canvas;
    let originalStyles = {};

    try {
      const element = document.querySelector("#rep1");
      originalStyles = {
        position: element.style.position,
        left: element.style.left,
        top: element.style.top,
        visibility: element.style.visibility,
      };

      element.style.position = "absolute";
      element.style.left = "-9999px";
      element.style.visibility = "visible";

      await new Promise((resolve) => setTimeout(resolve, 150));

      const pdf = new jsPDF("p", "mm", "a4");
      const canvas = await html2canvas(element, {
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: true,
        width: element.scrollWidth,
        height: element.scrollHeight,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth - 10;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(canvas, "PNG", 5, 5, imgWidth, imgHeight, undefined, "FAST");

      const blobPDF = new Blob([pdf.output("blob")], {
        type: "application/pdf",
      });

      const customerName = contact_name || CashContact?.name;
      const message = `Hi ${customerName}, Attached is your invoice. Let me know if you need anything else.`;

      const formData = new FormData();
      formData.append("image", blobPDF);
      formData.append("invoice_id", Invoice_no || 10);
      formData.append("contact_id", contact_id || CashContact?.id);
      formData.append("countrycode", 91);
      formData.append(
        "mobileno",
        selectedContact?.mobile || CashContact?.mobile
      );
      formData.append("wp_clientmsg", message);
      formData.append("contactType", 1);
      formData.append("AUTHORIZEKEY", AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));
      dispatch(setWhatsappBtn(false));

      const response = await fetch(
        `${baseurl}/expo_access_api/invoicePdfsendfdtowhatsapp/`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) throw new Error("Failed to send PDF");

      setShowgeneratetext(false);
      dispatch(setWhatsappBtn(false));
      toast.success("Invoice sent successfully!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      console.error("Error while generating or sending PDF:", error);
      dispatch(setWhatsappBtn(false));
    } finally {
      const element = document.querySelector("#rep1");
      if (element) {
        element.style.position = originalStyles.position || "";
        element.style.left = originalStyles.left || "";
        element.style.top = originalStyles.top || "";
        element.style.visibility = originalStyles.visibility || "";
      }
    }
  };

  useEffect(() => {
    const delay = 1000;
    let timeoutId;

    const delayedAPICall = async () => {
      try {
        setFirstAPICallMade(true);
        await getProductByBarcode(searchBarcode);
      } catch (error) {
        console.error("Error in getProductByBarcode API:", error);
      }
    };

    const handleChange = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(delayedAPICall, delay);
    };

    if (searchBarcode) {
      handleChange();
    }

    return () => clearTimeout(timeoutId);
  }, [searchBarcode]);

  // new json format
  const Saveattributejson = (index) => {
    if (!product_selectid || index < 0 || index >= pricelist_array.length)
      return;

    const selectedEntry = pricelist_array[index];

    if (selectedEntry) {
      const selectedprice = selectedEntry.price;
      const newSelectedJson = {
        [product_selectid]: combinedArrayToJSON(
          attr_label,
          selectedEntry.attr_arr
        ),
      };
      const newSelectedJsonName = {
        [product_selectid]: combinedArrayToJSONName(
          attr_label,
          selectedEntry.attr_arr
        ),
      };

      setJson(newSelectedJson);
      setJsonName(newSelectedJsonName);
      setCartinfo("Data found");
      getBranchWiseProductCurrentStock(
        selectedProduct,
        newSelectedJson,
        newSelectedJsonName,
        selectedprice
      );
    } else {
      console.error(`Product with ID ${product_selectid} not found.`);
    }
  };

  const combinedArrayToJSON = (attr_label, attr_arr) => {
    return Object.values(attr_label).reduce((result, attr, index) => {
      const value_id = String(attr.ID);
      const value = attr_arr[index]?.valueID;
      result[value_id] = value;
      return result;
    }, {});
  };

  const combinedArrayToJSONName = (attr_label, attr_arr) => {
    return Object.values(attr_label).reduce((result, attr, index) => {
      const label = attr.Label;
      const value = attr_arr[index]?.Value;
      result[label] = value;
      return result;
    }, {});
  };

  async function getProductPriceList(item, id, Productname, index) {
    try {
      if (id !== "") {
        const res = await axios.post(
          baseurl + "/expo_access_api/getProductPriceList/",
          {
            AUTHORIZEKEY: AUTHORIZE_KEY,
            product_id: id,
          }
        );

        if (res && res.data && res.data[0].STATUS == "SUCCESS") {
          const pricelistArray = res.data[0].DATA.pricelist_array;

          if (Array.isArray(pricelistArray) && pricelistArray.length != 0) {
            setAttrlabel(res.data[0].DATA.attrlabel_arr);
            setPricelistaarray(pricelistArray);
            setProductselectid(id);
            setAttrProductname(Productname);
            setSelectedprodindex(index);
            setShowattrmodal(!showattrmodal);
            setSelectedProduct(item);
            setProductImage(item.original_photo_path);
          } else {
            setCartloading(true);
            setCartinfo("Data found");
            setAttrlabel([]);
            setPricelistaarray([]);
            setProductselectid(id);
            setSelectedProduct(item);
            getBranchWiseProductCurrentStock(item, "", "", "");
          }
        } else {
          setCartloading(true);
          setCartinfo("Data found");
          setAttrlabel([]);
          setPricelistaarray([]);
          setProductselectid(id);
          setSelectedProduct(item);
          getBranchWiseProductCurrentStock(item, "", "", "");
        }
      }
    } catch (error) {
      console.error("Error while fetching product attributes:", error);
    }
  }

  const Openatrributemodal = (item, id, Productname, index) => {
    getProductPriceList(item, id, Productname, index);
  };

  const toggleattributemodal = () => {
    setShowattrmodal(!showattrmodal);
    setProductImage("");
  };

  const getBranchWiseProductCurrentStock = async (
    selectedProduct,
    selectedJson,
    selectedJson_Name,
    selectedprice
  ) => {
    try {
      const response = await axios.post(
        "/expo_access_api/getBranchWiseProductCurrentStock/",
        {
          AUTHORIZEKEY: AUTHORIZE_KEY,
          product_id: selectedProduct?.product_id,
          Attributes: selectedJson,
        }
      );

      if (response.data[0].STATUS === "SUCCESS") {
        const stock = response.data[0]?.DATA;
        if (stock == 0) {
          toast.error("Stock is not available!.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setProductselectid("");
          setCartloading(false);
          setCartinfo("Data not found");
        } else {
          setCartloading(false);
          setCartinfo("Data found");
          handleAddToCart(
            selectedProduct,
            selectedUnits[selectedProduct.product_id] || 1,
            stock,
            selectedJson,
            selectedJson_Name,
            selectedprice
          );
        }

        selectedJson !== "" && setShowattrmodal(!showattrmodal);
      } else {
        setCartloading(false);
      }
    } catch (error) {
      console.error("Error in getProductCategoryList API:", error);
    }
  };

  const [company_arr, setCompanyarr] = useState([]);
  const [branch_arr, setBrancharr] = useState([]);

  useEffect(() => {
    if (!Array.isArray(company_arr) || company_arr.length === 0) return;
    const normalizedCompanies = company_arr.map((cr) => String(cr?.company_id ?? cr?.id ?? ""));
    const currentCompany = String(selectedCompany ?? "");
    const hasSelectedCompany = normalizedCompanies.includes(currentCompany);
    if (!hasSelectedCompany) {
      dispatch(setSelectedCompany(normalizedCompanies[0]));
    }
  }, [company_arr, selectedCompany, dispatch]);

  useEffect(() => {
    if (!Array.isArray(branch_arr) || branch_arr.length === 0) return;
    const normalizedBranches = branch_arr.map((br) => String(br?.branch_id ?? br?.id ?? ""));
    const currentBranch = String(selectedBranch ?? "");
    const hasSelectedBranch = normalizedBranches.includes(currentBranch);
    if (!hasSelectedBranch) {
      dispatch(setSelectedBranch(normalizedBranches[0]));
    }
  }, [branch_arr, selectedBranch, dispatch]);

  const parseSupportApiArray = (response, arrKey) => {
    const dataRoot = Array.isArray(response?.data) ? response.data[0] : response?.data;
    if (dataRoot?.STATUS !== "SUCCESS") return [];
    const arr = dataRoot?.DATA?.[arrKey] || dataRoot?.DATA || [];
    return Array.isArray(arr) ? arr : [];
  };

  const postSupportApiWithFallback = async (endpointWithoutSlash, payload) => {
    const headers = {
      Authorization: AUTHORIZE_KEY,
      "Content-Type": "application/json",
    };
    try {
      return await axios.post(endpointWithoutSlash, payload, { headers });
    } catch (error) {
      return axios.post(`${endpointWithoutSlash}/`, payload, { headers });
    }
  };

  const fetchBranches = async () => {
    const payload = {
      AUTHORIZEKEY: AUTHORIZE_KEY,
      PHPTOKEN: localStorage.getItem("id_token"),
    };
    try {
      const response = await postSupportApiWithFallback("/supportportalapi/branches", payload);
      setBrancharr(parseSupportApiArray(response, "branch_arr"));
    } catch (error) {
      console.error("Error fetching branches:", error);
      setBrancharr([]);
    }
  };

  const fetchCompanies = async () => {
    const payload = {
      AUTHORIZEKEY: AUTHORIZE_KEY,
      PHPTOKEN: localStorage.getItem("id_token"),
    };
    try {
      const response = await postSupportApiWithFallback("/supportportalapi/companylist", payload);
      setCompanyarr(parseSupportApiArray(response, "company_arr"));
    } catch (error) {
      console.error("Error fetching companies:", error);
      setCompanyarr([]);
    }
  };

  useEffect(() => {
    fetchBranches();
    fetchCompanies();
  }, []);

  /* prev contact logic */
  const [contactmodal, setContactmodal] = useState(false);
  const togglecontact = () => {
    setContactmodal(!contactmodal);
    const fieldsToReset = [
      "name",
      "mobile",
      "email",
      "address_type",
      "address1",
      "address2",
      "area",
      "city",
      "zipcode",
    ];
    fieldsToReset.forEach((field) => setValue(field, ""));
  };

  // added by umang for add billing address
  const [nickname_billing, setNickNamebilling] = useState();
  const [address1_billing, setAddress1billing] = useState();
  const [address2_billing, setAddress2billing] = useState();
  const [area_billing, setAreabilling] = useState();
  const [city_billing, setCitybilling] = useState();
  const [selcountry_billing, setSelCountrybilling] = useState();
  const [selstate_billing, setSelStatebilling] = useState();
  const [zipcode_billing, setZipcodebilling] = useState();
  const [address_id, setAddressID] = useState("");
  const [billingmodal, setBillingmodal] = useState(false);
  const [billingadd, setBillingadd] = useState(false);

  // for select - option
  const [Address, setAddress] = useState([]);

  const togglebilling = () => {
    setBillingmodal(!billingmodal);
    setNickNamebilling("");
    setAddress1billing("");
    setAddress2billing("");
    setAreabilling("");
    setCitybilling("");
    setSelCountrybilling("India");
    setSelStatebilling("GUJARAT");
    setZipcodebilling("");
  };

  const handleChangeFieldbilling = (e) => {
    if (e.target.name == "txt_add_type_new_billing") {
      setNickNamebilling(e.target.value);
    } else if (e.target.name == "txt_add_new1_billing") {
      setAddress1billing(e.target.value);
    } else if (e.target.name == "txt_add_new2_billing") {
      setAddress2billing(e.target.value);
    } else if (e.target.name == "txt_city_new_billing") {
      setCitybilling(e.target.value);
    } else if (e.target.name == "txt_area_new_billing") {
      setAreabilling(e.target.value);
    } else if (e.target.name == "txt_zipcode_new_billing") {
      if (selcountry == "India") {
        const re = /^[0-9\b]+$/;
        if (e.target.value === "" || re.test(e.target.value)) {
          if (e.target.value.length > 6) {
          } else {
            setZipcodebilling(e.target.value);
          }
        }
      } else {
        setZipcodebilling(e.target.value);
      }
    } else if (e.target.name == "sel_state_new_billing") {
      setSelStatebilling(e.target.value);
    }
  };

  const fetchContactAddresses = async (
    contactid,
    {
      setBillingId = true,
      billingIdOverride = null,
      shippingIdOverride = null,
      sameAsBillingOverride = null,
    } = {}
  ) => {
    try {
      const url = baseurl + "/expo_access_api/getContactBillingAddressForBot/";

      // Fetch both billing and shipping addresses in parallel
      const [billingRes, shippingRes] = await Promise.all([
        axios.post(url, {
          AUTHORIZEKEY: AUTHORIZE_KEY,
          contact_id: contactid,
          billing_type: "Y",
          contact_type: 1,
        }),
        axios.post(url, {
          AUTHORIZEKEY: AUTHORIZE_KEY,
          contact_id: contactid,
          billing_type: "N",
          contact_type: 1,
        }),
      ]);

      const billingAddresses =
        billingRes.data[0].STATUS === "SUCCESS" ? billingRes.data[0].DATA : [];

      const shippingAddresses =
        shippingRes.data[0].STATUS === "SUCCESS" ? shippingRes.data[0].DATA : [];

      // Merge both, avoiding duplicates by address_id
      const allAddresses = [
        ...billingAddresses,
        ...shippingAddresses.filter(
          (s) => !billingAddresses.some((b) => b.address_id === s.address_id)
        ),
      ];

      setAddress(allAddresses);

      if (setBillingId) {
        const defaultBilling =
          billingIdOverride ||
          billingAddresses.find((a) => a.billing_flg === "Y")?.address_id ||
          allAddresses[0]?.address_id ||
          "";

        const defaultShipping =
          shippingIdOverride !== null
            ? shippingIdOverride
            : shippingAddresses.find((a) => a.billing_flg === "Y")?.address_id ||
            defaultBilling;

        const resolvedSameAsBilling =
          sameAsBillingOverride !== null
            ? sameAsBillingOverride
            : defaultBilling === defaultShipping;

        // ✅ KEY FIX: if sameAsBilling, force shippingAddressId = billingAddressId
        const finalShippingId = resolvedSameAsBilling
          ? defaultBilling
          : defaultShipping;

        dispatch(
          setAddressDetails({
            billingAddressId: defaultBilling,
            shippingAddressId: finalShippingId,
            sameAsBilling: resolvedSameAsBilling,
          })
        );

        if (defaultBilling) dispatch(setShowBillingModal(true));
        // Show shipping modal only when NOT same as billing
        if (!resolvedSameAsBilling) dispatch(setShowShippingModal(true));
      }
    } catch (error) {
      console.error("Error in fetchContactAddresses:", error);
      setAddress([]);
    }
  };



  const handleSubmitAddressBilling = (e) => {
    e.preventDefault();

    axios
      .post(baseurl + "/expo_access_api/saveContactAddress/", {
        AUTHORIZEKEY: AUTHORIZE_KEY,
        contact_id: contact_id,
        contact_type: 1,
        address_type: nickname_billing,
        address1: address1_billing,
        address2: address2_billing,
        area: area_billing,
        city: city_billing,
        selcountry: selcountry_billing,
        selstate: selstate_billing,
        zipcode: zipcode_billing,
        billing_flg: "Y",
        billing_type: 0,
      })
      .then((response) => {
        if (response.data[0].STATUS === "SUCCESS") {
          Swal.fire({
            title: response.data[0].MSG,
            icon: "success",
          });
          fetchContactAddresses(contact_id);
          setNickNamebilling("");
          setAddress1billing("");
          setAddress2billing("");
          setAreabilling("");
          setCitybilling("");
          setSelCountrybilling("India");
          setSelStatebilling("GUJARAT");
          setZipcodebilling("");
          togglebilling();
        } else {
          console.error(
            "Error in saveContactAddress API:",
            response.data[0].MSG
          );
        }
      })
      .catch((error) => {
        console.error("Error in saveContactAddress API:", error);
      });
  };

  // added by umang
  // for add shipping address
  const [nickname_shipping, setNickNameShipping] = useState();
  const [address1_shipping, setAddress1Shipping] = useState();
  const [address2_shipping, setAddress2Shipping] = useState();
  const [area_shipping, setAreaShipping] = useState();
  const [city_shipping, setCityShipping] = useState();
  const [selcountry_shipping, setSelCountryShipping] = useState();
  const [selstate_shipping, setSelStateShipping] = useState();
  const [zipcode_shipping, setZipcodeShipping] = useState();
  const [shippingmodal, setShippingmodal] = useState(false);
  const [shippigadd, setShippingadd] = useState(false);

  const toggleshipping = () => {
    setShippingmodal(!shippingmodal);
    setNickNameShipping("");
    setAddress1Shipping("");
    setAddress2Shipping("");
    setAreaShipping("");
    setCityShipping("");
    setSelCountryShipping("");
    setSelStateShipping("");
    setZipcodeShipping("");
  };

  const handleChangeFieldShipping = (e) => {
    if (e.target.name === "txt_add_type_new_shipping") {
      setNickNameShipping(e.target.value);
    } else if (e.target.name === "txt_add_new1_shipping") {
      setAddress1Shipping(e.target.value);
    } else if (e.target.name === "txt_add_new2_shipping") {
      setAddress2Shipping(e.target.value);
    } else if (e.target.name === "txt_city_new_shipping") {
      setCityShipping(e.target.value);
    } else if (e.target.name === "txt_area_new_shipping") {
      setAreaShipping(e.target.value);
    } else if (e.target.name === "txt_zipcode_new_shipping") {
      if (selcountry_shipping === "India") {
        const re = /^[0-9\b]+$/;
        if (e.target.value === "" || re.test(e.target.value)) {
          if (e.target.value.length > 6) {
          } else {
            setZipcodeShipping(e.target.value);
          }
        }
      } else {
        setZipcodeShipping(e.target.value);
      }
    } else if (e.target.name === "sel_state_new_shipping") {
      setSelStateShipping(e.target.value);
    }
  };

  const handleSubmitAddressShipping = (e) => {
    e.preventDefault();

    axios
      .post(baseurl + "/expo_access_api/saveContactAddress/", {
        AUTHORIZEKEY: AUTHORIZE_KEY,
        contact_id: contact_id,
        contact_type: 1,
        address_type: nickname_shipping,
        address1: address1_shipping,
        address2: address2_shipping,
        area: area_shipping,
        city: city_shipping,
        selcountry: selcountry_shipping,
        selstate: selstate_shipping,
        zipcode: zipcode_shipping,
        billing_flg: "Y",
        billing_type: 1,
      })
      .then((response) => {
        if (response.data[0].STATUS === "SUCCESS") {
          Swal.fire({
            title: response.data[0].MSG,
            icon: "success",
          });
          fetchContactAddresses(contact_id);
          setNickNameShipping("");
          setAddress1Shipping("");
          setAddress2Shipping("");
          setAreaShipping("");
          setCityShipping("");
          setSelCountryShipping("India");
          setSelStateShipping("GUJARAT");
          setZipcodeShipping("");
          toggleshipping();
        } else {
          console.error(
            "Error in saveContactAddress API:",
            response.data[0].MSG
          );
        }
      })
      .catch((error) => {
        console.error("Error in saveContactAddress API:", error);
      });
  };

  const [contacts, setContacts] = useState([]);
  const [country, setCountry] = useState([]);
  const [State, setState] = useState([]);
  const [selcountry, setSelCountry] = useState("");
  const [addcontact, setAddContact] = useState({
    name: "",
    mobile: "",
    email: "",
    address_type: "",
    address1: "",
    address2: "",
    country: "",
    area: "",
    state: "",
    city: "",
    zipcode: "",
  });
  const [contactbtn, setContactbtn] = useState(false);

  const animatedComponents = makeAnimated();

  useEffect(() => {
    submitfile();
  }, []);

  const [CashContact, setCashContact] = useState({});
  async function submitfile() {
    try {
      let url = "/expo_access_api/getContactTextile/";
      const res = await axios.post(url, {
        AUTHORIZEKEY: AUTHORIZE_KEY,
        created_by: 1,
      });

      if (res.data[0].STATUS === "SUCCESS") {
        const cashContact = res.data[0].DATA.find(
          (contact) => contact.name == "Cash Contact"
        );
        setContacts(res.data[0].DATA);
        setCashContact(cashContact);
      }
    } catch (error) {
      console.error("Error in API call:", error);
    }
  }

  const getCountryList = (e) => {
    async function findCountryList() {
      try {
        let url = "/expo_access_api/getCountryList/";
        const res = await axios.post(url, {
          AUTHORIZEKEY: AUTHORIZE_KEY,
        });

        if (res.data[0].STATUS === "SUCCESS") {
          setCountry(res.data[0].DATA);
          setValue("country", "India");
          changestate(e, "India");
        }
      } catch (error) {
        console.error("Error in getCountryList API:", error);
      }
    }

    findCountryList();
  };

  const changestate = (e, val) => {
    var element_val = val === 0 ? e.target.value : val;
    setSelCountry(element_val);
    setSelCountrybilling(element_val);
    setSelCountryShipping(element_val);
    setAddContact({ ...addcontact, country: element_val });

    async function getStates() {
      try {
        const res = await axios.post(
          "/expo_access_api/getstatelist/",
          {
            AUTHORIZEKEY: AUTHORIZE_KEY,
            COUNTRY: element_val,
          }
        );

        if (res.data[0].STATUS === "SUCCESS") {
          if (res.data[0].DATA.state) {
            setState(res.data[0].DATA.state);
            setValue("state", "GUJARAT");
          }
        } else {
          Swal.fire("Not Found", "State Not Found", "error");
          setState([]);
        }
      } catch (error) {
        console.error("Error in getStates API:", error);
      }
    }

    getStates();
  };

  useEffect(() => {
    getCountryList();
  }, []);

  const handleSubmitContact = async (data, e) => {
    setContactbtn(true);
    e.preventDefault();

    async function submitContact() {
      try {
        let url = "/ecommerce_api/saveContactPOS/";
        const res = await axios.post(url, {
          contact: data,
        });

        if (res.data[0].STATUS == "SUCCESS" && res.data[0].DATA > 0) {
          const fieldsToReset = [
            "name",
            "mobile",
            "email",
            "address_type",
            "address1",
            "address2",
            "area",
            "city",
            "zipcode",
          ];
          fieldsToReset.forEach((field) => setValue(field, ""));

          await submitfile();
          const contactId = res.data[0].DATA;

          dispatch(setContactDetails({
            id: contactId,
            name: data.name,
            number: data.mobile
          }));

          setContactbtn(false);
          setContactmodal(!togglecontact);
          setBillingadd(true);
          Swal.fire("Good job!", "Contact " + res.data[0].MSG, "success");
          fetchContactAddresses(contactId);
        } else {
          Swal.fire("Something went wrong", res.data[0].MSG, "error");
          setContactbtn(false);
        }
      } catch (error) {
        console.error("Error in submitContact API:", error);
        setContactbtn(false);
      } finally {
        setContactbtn(false);
      }
    }

    submitContact();
  };

  const [selectedContact, setSelectedContact] = useState(null);
  useEffect(() => {
    const updatedSelectedContact = contacts.find(
      (contact) => contact.id == contact_id
    );
    setSelectedContact(updatedSelectedContact);
  }, [contact_id, contacts]);


  // Also update the handleSelectChange function:
  const handleSelectChange = (selectedOption) => {
    if (!selectedOption) {
      dispatch(setContactDetails({
        id: "",
        name: "",
        number: ""
      }));
      dispatch(setShowBillingModal(false));
      dispatch(setShowShippingModal(false));
      return;
    }

    dispatch(setContactDetails({
      id: selectedOption.value,
      name: selectedOption.contactname,
      number: selectedOption.mobile
    }));
    // Enforce flow: after contact select -> show billing + same-as-billing checked
    fetchContactAddresses(selectedOption.value, {
      sameAsBillingOverride: true,
    });
    dispatch(setShowBillingModal(true));
    dispatch(setShowShippingModal(false));
    dispatch(setAddCustomerDetails(true)); // Make sure this is set
  };

  const handleCustomerDetailsToggle = () => {
    const nextValue = !addCustomerDetails;
    dispatch(setAddCustomerDetails(nextValue));

    if (nextValue) {
      // Fresh flow on enable: contact first, then billing/shipping based on selections
      dispatch(setShowBillingModal(false));
      dispatch(setShowShippingModal(false));
      return;
    }

    // Clear dependent UI when disabled
    dispatch(setShowBillingModal(false));
    dispatch(setShowShippingModal(false));
  };

  // Add this useEffect to prevent checkbox flickering
  // const [localSameAsBilling, setLocalSameAsBilling] = useState(sameAsBilling);

  // // Sync local state with Redux state
  // useEffect(() => {
  //   setLocalSameAsBilling(sameAsBilling);
  // }, [sameAsBilling]);

  // Update handleCheckboxChange to use local state
  const handleCheckboxChange = () => {
    const newSameAsBilling = !sameAsBilling;

    dispatch(
      setAddressDetails({
        billingAddressId: Billingaddress_id,
        // ✅ KEY FIX: checking = copy billing into shipping
        shippingAddressId: newSameAsBilling ? Billingaddress_id : Shippingaddress_id,
        sameAsBilling: newSameAsBilling,
      })
    );

    if (newSameAsBilling) {
      dispatch(setShowShippingModal(false));
    } else {
      dispatch(setShowShippingModal(true));
    }
  };

  /***************** MANAGING CATEGORY AND PRODUCT DISPLAYS *****************/

  const [categoryData, setCategoryData] = useState([]);
  const [MaincategoryData, setMaincategoryData] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [displayFilteredItems, setDisplayFilteredItems] = useState([]);

  const [categoryProducts, setCategoryProducts] = useState([]);
  const [isSelected, setIsSelected] = useState("");

  const [loading, setLoading] = useState(true);
  const [category_info, setCategoryinfo] = useState("");
  const [product_info, setProductinfo] = useState("");

  // Maincategories
  const fetchMaincategories = async () => {
    try {
      const response = await axios.post(
        "/ecommerce_api/getProductCategoryList/",
        {
          tree: true,
          AUTHORIZEKEY: AUTHORIZE_KEY,
          PHPTOKEN: localStorage.getItem("id_token"),
        }
      );

      if (response.data[0].STATUS === "SUCCESS") {
        setMaincategoryData(response.data[0].DATA.categorylist);
      } else {
        setMaincategoryData([]);
        setCategoryinfo("Data Not Found");
      }
    } catch (error) {
      console.error("Error in getProductCategoryList API:", error);
    }
  };

  useEffect(() => {
    fetchMaincategories();
  }, []);

  // Subcategories
  const fetchSubcategories = async () => {
    try {
      const response = await axios.post(
        "/ecommerce_api/getProductCategoryList/",
        {
          tree: false,
          AUTHORIZEKEY: AUTHORIZE_KEY,
          PHPTOKEN: localStorage.getItem("id_token"),
        }
      );

      if (response.data[0].STATUS === "SUCCESS") {
        setCategoryData(response.data[0].DATA.categorylist);
      } else {
        setCategoryData([]);
      }
    } catch (error) {
      console.error("Error in getProductCategoryList API:", error);
    }
  };

  useEffect(() => {
    fetchSubcategories();
  }, []);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const response = await axios.post(
          "/ecommerce_api/getCategorywiseProductList/",
          {
            category_name: "ALL",
          }
        );

        if (response.data[0].STATUS === "SUCCESS") {
          const data = response.data[0]?.DATA;
          const filteredItems = data ? data.products : [];

          if (filteredItems && filteredItems.length > 0) {
            setAllProducts(filteredItems);
            setDisplayFilteredItems(filteredItems);
          } else {
            setDisplayFilteredItems([]);
          }
        } else {
          console.error("Error fetching data:", response.data[0].MSG);
        }
      } catch (error) {
        console.error("Error in getCategorywiseProductList API:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // fetchCategorywiseProductList
  const fetchCategorywiseProductList = async () => {
    setProductinfo("Data Found");
    setDisplayFilteredItems([]);
    try {
      const response = await axios.post(
        "/ecommerce_api/getCategorywiseProductList/",
        {
          category_name: selectedCategory,
        }
      );

      if (response.data[0].STATUS === "SUCCESS") {
        const data = response.data[0]?.DATA;
        const fetchedItems = data ? data.products : [];
        setCategoryProducts(fetchedItems);
        setDisplayFilteredItems(fetchedItems);
      } else {
        console.error("Error fetching data:", response.data[0].MSG);
        setCategoryProducts([]);
        setDisplayFilteredItems([]);
        setProductinfo("Data Not Found");
      }
    } catch (error) {
      console.error("Error in getCategorywiseProductList API:", error);
      setCategoryProducts([]);
      setDisplayFilteredItems([]);
      setProductinfo("Data Not Found");
    } finally {
      setLoading(false);
      setProductinfo("Data Not Found");
    }
  };

  const getProductByBarcode = async (bar_code) => {
    try {
      const response = await axios.post(
        "/expo_access_api/ProductdetailByBarcode/",
        {
          barcode: bar_code,
          AUTHORIZEKEY: AUTHORIZE_KEY,
        }
      );

      if (!response.data || typeof response.data !== 'object') {
        throw new Error("Invalid API response structure");
      }

      if (Array.isArray(response.data) && response.data.length == 0) {
        throw new Error("No product data returned");
      }

      if (response.data[0]?.STATUS == "SUCCESS") {
        const data = response.data[0]?.DATA;

        if (!data || !data.Product_Details || !Array.isArray(data.Product_Details)) {
          throw new Error("Invalid product data structure");
        }

        const fetchedItems = data.Product_Details;
        const item = fetchedItems[0];

        if (item) {
          await getProductPriceList(item, item.product_id, item.name, "");
        } else {
          throw new Error("No product details available");
        }
      } else {
        const errorMessage = response.data[0]?.DATA?.MSG || "Product not available";
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error(error.message || "Error fetching product data", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  useEffect(() => {
    if (!selectedCategory) {
      return;
    }

    setLoading(true);
    fetchCategorywiseProductList();
  }, [selectedCategory]);

  const handleCategoryClick = (clickedCategory) => {
    if (isInvoiceSaved) {
      toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
    dispatch(setSelectedCategory(clickedCategory));
    setProductinfo("Data Found");
  };

  const handleCategorySearchChange = (event) => {
    dispatch(setCategorySearchQuery(event.target.value.toLowerCase()));
  };

  const [filteredCategories, setFilteredCategories] = useState([]);
  const [categoriesToDisplay, setCategoriesToDisplay] = useState([]);

  useEffect(() => {
    const fetchFilteredCategories = async () => {
      try {
        const filteredCategoriesResult = categoryData.filter((item) => {
          return item.name
            .toLowerCase()
            .includes(categorySearchQuery.toLowerCase());
        });
        if (filteredCategoriesResult.length == 0 && categorySearchQuery != "") {
          setCategoryinfo("Data Not Found");
        } else {
        }
        setFilteredCategories(filteredCategoriesResult);
      } finally {
      }
    };

    fetchFilteredCategories();
  }, [categoryData, categorySearchQuery]);

  useEffect(() => {
    setCategoriesToDisplay(
      categorySearchQuery ? filteredCategories : categoryData
    );
  }, [categorySearchQuery, filteredCategories, categoryData]);

  /************************ SEARCH *************************/
  useEffect(() => {
    if (categoryProducts.length == 0) {
      const filteredItems = allProducts.filter((item) => {
        const isNameMatch = item.name
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
        const isIdMatch = item.product_id.toString() === searchQuery.trim();
        return isNameMatch || isIdMatch;
      });
      if (filteredItems.length == 0 && searchQuery != "") {
        setProductinfo("Data Not Found");
      } else {
      }
      setDisplayFilteredItems(filteredItems);
    } else {
      const filteredItems = categoryProducts.filter((item) => {
        const isNameMatch = item.name
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
        const isIdMatch = item.product_id.toString() === searchQuery.trim();
        return isNameMatch || isIdMatch;
      });
      if (filteredItems.length == 0 && searchQuery != "") {
        setProductinfo("Data Not Found");
      } else {
      }
      setDisplayFilteredItems(filteredItems);
    }
  }, [searchQuery, categoryProducts]);

  /**************** DRAFTS ****************/

  const notifyDraft = () =>
    toast.success("Added to Drafts!", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });

  const addDraft = (draft) => {
    dispatch(addDraftItem(draft));
    notifyDraft();
  };

  const clearCart = () => {
    dispatch(clearCartAction());
  };

  const refillCartFromDraft = (draft) => {
    const updatedSelectedUnits = draft.items.reduce((acc, item, index) => {
      acc[index] = item.selectedUnit;
      return acc;
    }, {});

    dispatch(setSelectedUnits(updatedSelectedUnits));
    dispatch(setCart(draft.items));

    // Calculate and set subTArray
    const newSubTArray = draft.items.map((item, i) =>
      calculateSubT(item, updatedSelectedUnits[i] || 1)
    );
    dispatch(setSubTArray(newSubTArray));
  };

  // ✅ Refetch addresses on page refresh if contact_id exists in Redux
  useEffect(() => {
    if (contact_id && addCustomerDetails) {
      fetchContactAddresses(contact_id, {
        setBillingId: false, // ✅ Don't override existing Redux address values
        billingIdOverride: Billingaddress_id,
        shippingIdOverride: Shippingaddress_id,
        sameAsBillingOverride: sameAsBilling,
      });
    }
  }, []); // ✅ Empty array = runs only once on mount

  const handleEdit = (draft, drafts) => {
    if (isInvoiceSaved) {
      toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    // Clear current state first
    dispatch(resetForNewInvoice());

    // Wait for state to clear before refilling
    setTimeout(() => {
      refillCartFromDraft(draft);

      if (draft.contactid != "") {
        dispatch(setAddCustomerDetails(true));
        dispatch(setContactDetails({
          id: draft.contactid,
          name: draft.contactName,
          number: draft.contactMobileNumber
        }));

        // ✅ Set ALL address details from draft FIRST - CRITICAL FIX
        dispatch(setAddressDetails({
          billingAddressId: draft.BillingaddressId || "",
          shippingAddressId: draft.ShippingaddressId || "",
          sameAsBilling: draft.Ship_Bill_Same || false // ✅ Use draft's value, default to false if undefined
        }));

        // ✅ Set modal visibility based on sameAsBilling from draft
        if (draft.Ship_Bill_Same) {
          dispatch(setShowBillingModal(true));
          dispatch(setShowShippingModal(false));
        } else {
          dispatch(setShowBillingModal(true));
          dispatch(setShowShippingModal(true));
        }

        // ✅ Only fetch addresses if needed (for dropdown population)
        // But DON'T let it override our draft values
        if (draft.contactid) {
          // Create a modified version of contact_address_draft that doesn't override addresses
          fetchContactAddresses(draft.contactid, {
            setBillingId: true,
            billingIdOverride: draft.BillingaddressId || "",
            shippingIdOverride: draft.ShippingaddressId || "",
            sameAsBillingOverride: draft.Ship_Bill_Same ?? false,
          });
        }
      } else {
        // If no contact, set to defaults
        dispatch(setAddCustomerDetails(false));
        dispatch(setShowBillingModal(false));
        dispatch(setShowShippingModal(false));
      }

      // Remove draft after refilling
      dispatch(removeDraftItem(draft));
      dispatch(toggleModal());
    }, 100);
  };

  // ✅ Add this new function to fetch addresses ONLY for dropdown, not to override
  // const fetchAddressesForDropdownOnly = async (contactid, billingAddressId, shippingAddressId) => {
  //   try {
  //     let url = baseurl + "/expo_access_api/getContactBillingAddressForBot/";
  //     const res = await axios.post(url, {
  //       AUTHORIZEKEY: AUTHORIZE_KEY,
  //       contact_id: contactid,
  //       billing_type: "Y",
  //       contact_type: 1,
  //     });

  //     if (res.data[0].STATUS === "SUCCESS") {
  //       // ✅ Only set the Address state for dropdown, don't dispatch any address details
  //       setAddress(res.data[0].DATA);
  //     } else {
  //       console.error("Error fetching data:", res.data[0].MSG);
  //       setAddress([]);
  //     }
  //   } catch (error) {
  //     console.error("Error in getContactBillingAddressForBot API:", error);
  //     setAddress([]);
  //   }
  // };

  const handleDelete = (draft, drafts) => {
    Swal.fire({
      title: 'Delete Draft?',
      html: `
      <div style="text-align: center;">
        <p>Are you sure you want to delete this draft?</p>
        <p style="font-size: 14px; color: #666;">
          <strong>Contact:</strong> ${draft.contactName || 'No Contact'} <br/>
          <strong>Items:</strong> ${draft.numberOfItems} <br/>
          <strong>Total:</strong> ₹${parseFloat(draft.total).toFixed(2)}
        </p>
        <p style="font-size: 12px; color: #999;">
          This action cannot be undone.
        </p>
      </div>
    `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      focusCancel: true,
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-secondary'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeDraftItem(draft));

        Swal.fire({
          title: 'Deleted!',
          text: 'Draft has been deleted.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false
        });

        if (drafts.length === 1) {
          setTimeout(() => {
            dispatch(toggleModal());
          }, 1500);
        }
      }
    });
  };

  /********************************* CART *********************************/

  const [cart_loading, setCartloading] = useState(false);
  const [cart_info, setCartinfo] = useState("Data not found");
  const [activeCartCardIndex, setActiveCartCardIndex] = useState(null);

  useEffect(() => {
    if (cart.length === 0) {
      setCartinfo("Data not found");
    } else {
      setCartinfo("Data found");
    }
  }, [cart]);

  useEffect(() => {
    if (cart.length === 0) {
      setActiveCartCardIndex(null);
      return;
    }
    if (
      activeCartCardIndex === null ||
      activeCartCardIndex < 0 ||
      activeCartCardIndex >= cart.length
    ) {
      setActiveCartCardIndex(0);
    }
  }, [cart, activeCartCardIndex]);

  const handleAddToCart = (
    selectedProduct,
    selectedUnit,
    prod_stock,
    selectedJson,
    selectedJson_Name,
    selectedprice
  ) => {
    const existingProductIndex = cart.findIndex(
      (item) =>
        item.product_id == selectedProduct.product_id &&
        item.stock == prod_stock
    );

    let updatedCart;

    if (existingProductIndex !== -1) {
      // Update existing product quantity
      updatedCart = cart.map((item, idx) => {
        if (idx === existingProductIndex) {
          const newQuantity = item.quantity + 1;
          const validatedQuantity = Math.max(0, newQuantity);

          if (validatedQuantity > parseFloat(item.stock, 10)) {
            setInvalidInput(existingProductIndex);
            toast.error("Quantity should not be greater than available stock.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            return item;
          }

          setInvalidInput(null);

          // Calculate new values
          const selectedUnit = selectedUnits[existingProductIndex] || 1;
          const subtotal = calculateSubT({ ...item, quantity: validatedQuantity }, selectedUnit);
          const discount = calculateDiscount({ ...item, quantity: validatedQuantity }, selectedUnit);
          const validDiscount = !isNaN(discount) ? discount : 0;
          const tax = (subtotal * item.taxPercentage) / 100;
          const discountedSubtotal = subtotal - validDiscount;
          const total = discountedSubtotal + tax;

          return {
            ...item,
            quantity: validatedQuantity,
            discount,
            amount: total.toFixed(2),
          };
        }
        return item;
      });
    } else {
      // Add new product
      const newCartItem = {
        product_id: selectedProduct.product_id,
        name: selectedProduct.name,
        mrp_price: selectedprice || selectedProduct.price1_min,
        original_photo_path: selectedProduct.original_photo_path,
        quantity: 1,
        packing: selectedProduct.proddivision,
        unit_name: selectedProduct.unit_name,
        second_unit: selectedProduct.second_unit,
        conv_factor: selectedProduct.prod_conversion,
        taxPercentage: selectedProduct.Tax,
        selectedUnit: selectedUnit || 1,
        stock: Number(prod_stock),
        product_attribute: selectedJson,
        product_attribute_Name: JSON.parse(JSON.stringify(selectedJson_Name)),
        productstockid: !!selectedProduct.ProductStockid
          ? selectedProduct.ProductStockid
          : "",
        discount: 0,
        discountPercentage: 0,
        amount: selectedprice || selectedProduct.price1_min,
      };

      updatedCart = [...cart, newCartItem];

      // Update selected units for new item
      const newSelectedUnits = { ...selectedUnits };
      newSelectedUnits[updatedCart.length - 1] = selectedUnit || 1;
      dispatch(setSelectedUnits(newSelectedUnits));
    }

    dispatch(setCart(updatedCart));

    // Recalculate subTArray
    const newSubTArray = updatedCart.map((item, i) =>
      calculateSubT(item, selectedUnits[i] || 1)
    );
    dispatch(setSubTArray(newSubTArray));

    setProductselectid("");
  };

  const handleRemoveFromCart = (productId, index) => {
    dispatch(removeFromCart(index));

    // Recalculate subTArray after removal
    const newCart = cart.filter((item, i) => i !== index);
    const newSubTArray = newCart.map((item, i) =>
      calculateSubT(item, selectedUnits[i] || 1)
    );
    dispatch(setSubTArray(newSubTArray));
  };

  const [invalidInput, setInvalidInput] = useState(null);

  // Fix handleQuantityInputChange:
  const handleQuantityInputChange = (rowIndex, newQuantity) => {
    // Create a new cart array instead of modifying existing one
    const updatedCart = cart.map((item, idx) => {
      if (idx === rowIndex) {
        const validatedQuantity = Math.max(0, parseFloat(newQuantity, 10) || 0);

        if (validatedQuantity > parseFloat(item.stock, 10)) {
          setInvalidInput(rowIndex);
          toast.error("Quantity should not be greater than available stock.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          return item; // Return unchanged item
        }
        setInvalidInput(null);

        // Calculate new values
        const selectedUnit = selectedUnits[rowIndex] || 1;
        const subtotal = calculateSubT({ ...item, quantity: validatedQuantity }, selectedUnit);
        const discount = calculateDiscount({ ...item, quantity: validatedQuantity }, selectedUnit);
        const validDiscount = !isNaN(discount) ? discount : 0;
        const tax = (subtotal * item.taxPercentage) / 100;
        const discountedSubtotal = subtotal - validDiscount;
        const total = discountedSubtotal + tax;

        // Return new object with updated values
        return {
          ...item,
          quantity: validatedQuantity,
          discount,
          amount: total.toFixed(2),
        };
      }
      return item;
    });

    dispatch(setCart(updatedCart));

    // Recalculate subTArray
    const newSubTArray = updatedCart.map((item, i) =>
      calculateSubT(item, selectedUnits[i] || 1)
    );
    dispatch(setSubTArray(newSubTArray));
  };

  const handleChangeRate = (rowIndex, newRate) => {
    const updatedCart = cart.map((item, idx) => {
      if (idx === rowIndex) {
        const validatedRate = Math.max(0, parseFloat(newRate) || 0);
        setInvalidInput(null);

        const selectedUnit = selectedUnits[rowIndex] || 1;
        const subtotal = calculateSubT({ ...item, mrp_price: validatedRate }, selectedUnit);
        const discount = calculateDiscount({ ...item, mrp_price: validatedRate }, selectedUnit);
        const validDiscount = !isNaN(discount) ? discount : 0;
        const tax = (subtotal * item.taxPercentage) / 100;
        const discountedSubtotal = subtotal - validDiscount;
        const total = discountedSubtotal + tax;

        return {
          ...item,
          mrp_price: validatedRate,
          discount,
          amount: total.toFixed(2),
        };
      }
      return item;
    });

    dispatch(setCart(updatedCart));

    // Recalculate subTArray
    const newSubTArray = updatedCart.map((item, i) =>
      calculateSubT(item, selectedUnits[i] || 1)
    );
    dispatch(setSubTArray(newSubTArray));
  };

  /************************* DATA TABLE *************************/

  const style2 = { width: 25, fontSize: 14, padding: 1 };

  const [unitChangeCount, setUnitChangeCount] = useState(0);

  useEffect(() => {
    const updatedSubTArray = cart.map((item, i) =>
      calculateSubT(item, selectedUnits[i] || 1)
    );
    dispatch(setSubTArray(updatedSubTArray));
  }, [cart, unitChangeCount, selectedUnits, dispatch]);

  const calculateSubT = (item, selectedUnit) => {
    const quantity = Number(item.quantity);
    const mrpPrice = Number(item.mrp_price);
    const convFactor = Number(item.conv_factor) || 1;

    if (Number(selectedUnit) === 1) {
      return mrpPrice * quantity;
    } else if (Number(selectedUnit) === 2) {
      return (quantity / convFactor) * mrpPrice;
    } else {
      return 0;
    }
  };

  const calculateTax = (item, selectedUnit, index) => {
    const taxPercentage = Number(item.taxPercentage);
    const taxAmount = (subTArray[index] * taxPercentage) / 100;
    return taxAmount.toFixed(2);
  };

  const handleUnitChange = (index, selectedUnit) => {
    // Update selected units
    dispatch(updateSelectedUnit({ index, unit: selectedUnit }));

    // Update cart item
    const updatedCart = cart.map((item, idx) => {
      if (idx === index) {
        const newSubT = calculateSubT({ ...item, selectedUnit: Number(selectedUnit) }, selectedUnit);
        const discount = calculateDiscount({ ...item, selectedUnit: Number(selectedUnit) }, selectedUnit);
        const validDiscount = !isNaN(discount) ? discount : 0;
        const tax = (newSubT * item.taxPercentage) / 100;
        const discountedSubtotal = newSubT - validDiscount;
        const total = discountedSubtotal + tax;

        return {
          ...item,
          selectedUnit: Number(selectedUnit),
          discount,
          amount: total.toFixed(2),
        };
      }
      return item;
    });

    dispatch(setCart(updatedCart));

    // Recalculate subT
    const newSubT = calculateSubT(cart[index], selectedUnit);
    const updatedSubTArray = [...subTArray];
    updatedSubTArray[index] = newSubT;
    dispatch(setSubTArray(updatedSubTArray));

    setUnitChangeCount((prevCount) => prevCount + 1);
  };

  const productColumns = [
    {
      name: "Image",
      selector: (row) => (
        <div className="popover-attribute">
          <OverlayTrigger
            trigger="hover"
            key={row.id}
            placement="right"
            overlay={
              <Popover id={`popover-positioned-${row.id}`}>
                <Popover.Header as="h3">{row.name}</Popover.Header>
                <Popover.Body>
                  <ul>
                    {row.product_attribute_Name[row.product_id] ? (
                      <ul>
                        {Object.entries(
                          row.product_attribute_Name[row.product_id]
                        ).map(
                          ([attribute, value]) =>
                            value && (
                              <li key={attribute}>
                                <strong style={{ fontWeight: "bolder" }}>
                                  {attribute}:
                                </strong>{" "}
                                {value}
                              </li>
                            )
                        )}
                      </ul>
                    ) : (
                      <span>No attributes available</span>
                    )}
                  </ul>
                </Popover.Body>
              </Popover>
            }
          >
            <img
              height="45px"
              width="45px"
              alt={row.name}
              src={row.original_photo_path}
              padding="0"
              style={{ borderRadius: "6px", cursor: "pointer" }}
            />
          </OverlayTrigger>
        </div>
      ),
      sortable: true,
      center: true,
      minWidth: "70px",
      maxWidth: "70px",
    },
    {
      name: "Product",
      selector: (row) => (
        <span style={{ paddingRight: "5px" }}>{row.name}</span>
      ),
      sortable: true,
      center: true,
      wrap: true,
      minWidth: "120px",
    },
    {
      name: "Unit",
      cell: (row, index) =>
        index !== cart.length ? (
          <Form.Select
            aria-label="Default select example"
            size="sm"
            style={{ width: "80px", padding: "4px", maxHeighteight: "25px", cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
            onChange={(e) => {
              handleUnitChange(index, e.target.value, row);
            }}
            disabled={isInvoiceSaved}
          >
            {row.unit_name != "" && (
              <option value="1" selected={row.selectedUnit == 1}>
                {row.unit_name}
              </option>
            )}
            {row.second_unit != "" && (
              <option value="2" selected={row.selectedUnit == 2}>
                {row.second_unit}
              </option>
            )}
          </Form.Select>
        ) : null,
      sortable: true,
      center: true,
      minWidth: "100px",
      maxWidth: "100px",
      padding: "0",
    },
    {
      name: "Qty",
      cell: (row, index) =>
        index != cart.length ? (
          <div
            className={`qty-input-grp d-flex-row${invalidInput == index || (showQtyRed && row.quantity == 0)
              ? " qty-input-grp-red"
              : ""
              }`}
          >
            <Form.Control
              type="number"
              size="sm"
              value={row.quantity.toString()}
              onChange={(e) => handleQuantityInputChange(index, e.target.value)}
              style={{ width: "70px", cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
              disabled={isInvoiceSaved}
            />
          </div>
        ) : null,
      selector: (row) => row.quantity,
      sortable: true,
      center: true,
      minWidth: "95px",
      maxWidth: "110px",
    },
    {
      name: "Stock",
      selector: (row) => (
        <span style={{ paddingLeft: "5px" }}>{row.stock}</span>
      ),
      sortable: true,
      center: true,
      minWidth: "65px",
      maxWidth: "65px",
    },
    {
      name: "Rate",
      cell: (row, index) =>
        index !== cart.length ? (
          <Form.Control
            type="number"
            size="sm"
            value={row.mrp_price ? row.mrp_price.toString() : ""}
            onChange={(e) => handleChangeRate(index, e.target.value)}
            style={{ width: "70px", cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
            disabled={isInvoiceSaved}
          />
        ) : null,
      sortable: true,
      center: true,
      minWidth: "85px",
      maxWidth: "85px",
    },
    {
      name: (
        <span>
          Gross
          <br />
          Amount
        </span>
      ),
      selector: (row, index) => Number(subTArray[index]).toFixed(2),
      sortable: true,
      center: true,
      minWidth: "90px",
      maxWidth: "90px",
    },
    {
      name: (
        <span>
          Disc
          <br />
          (%)
        </span>
      ),
      cell: (row, index) =>
        index !== cart.length ? (
          <Form.Control
            type="text"
            size="sm"
            value={row.discountPercentage}
            onChange={(e) =>
              handleDiscountChange(index, "percentage", e.target.value)
            }
            disabled={isInvoiceSaved}
            style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
          />
        ) : null,
      sortable: true,
      center: true,
      minWidth: "85px",
      maxWidth: "85px",
    },
    {
      name: "Disc",
      cell: (row, index) =>
        index !== cart.length ? (
          <Form.Control
            type="text"
            size="sm"
            value={row.discount}
            onChange={(e) =>
              handleDiscountChange(index, "amount", e.target.value)
            }
            style={{ width: "70px", cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
            disabled={isInvoiceSaved}
          />
        ) : null,
      sortable: true,
      center: true,
      minWidth: "75px",
      maxWidth: "75px",
    },
    {
      name: (
        <span>
          Tax
          <br />
          (%)
        </span>
      ),
      selector: (row) => row.taxPercentage,
      sortable: true,
      center: true,
      minWidth: "45px",
      maxWidth: "45px",
    },
    {
      name: "Tax",
      selector: (row, index) => calculateTax(row, selectedUnits[index], index),
      sortable: true,
      center: true,
      minWidth: "65px",
      maxWidth: "65px",
    },
    {
      name: (
        <span>
          Payable
          <br />
          Amount
        </span>
      ),
      selector: (row, index) => row.amount,
      sortable: true,
      center: true,
      minWidth: "70px",
      maxWidth: "150px",
    },
    {
      name: "",
      cell: (row, index) => (
        <div>
          <span>
            <button
              style={{
                width: 25,
                fontSize: 14,
                padding: 1,
                textAlign: "center",
              }}
              color="danger"
              className="btn btn-xs"
              type="button"
              onClick={() => handleRemoveFromCart(row.product_id, index)}
              disabled={isInvoiceSaved}
            >
              <Btn
                attrBtn={{
                  style: style2,
                  color: "danger",
                  className: "btn btn-xs action-button",
                  type: "button",
                  disabled: isInvoiceSaved
                }}
              >
                <FiTrash size={15} />
              </Btn>
            </button>
          </span>
        </div>
      ),
      sortable: false,
      center: true,
      minWidth: "35px",
      maxWidth: "35px",
    },
  ];

  /************************* BILL SUMMARY *************************/
  const calculateBillSummary = () => {
    const totalItems = cart.length;
    const actualTotalPrice = cart.reduce((total, item, index) => {
      return total + subTArray[index];
    }, 0);

    const totalTaxes = cart.reduce((total, item, index) => {
      const taxRate = Number.isFinite(item.taxPercentage)
        ? item.taxPercentage / 100
        : 0;
      const itemTax = subTArray[index] * taxRate || 0;
      return total + itemTax;
    }, 0);

    const totalDiscount = cart.reduce((total, item) => {
      return total + Number(item.discount);
    }, 0);

    const overallTotal = Number(actualTotalPrice + totalTaxes - totalDiscount);

    return {
      totalItems,
      actualTotalPrice: Number(actualTotalPrice.toFixed(2)),
      totalDiscount: Number(totalDiscount.toFixed(2)),
      totalTaxes: Number(totalTaxes.toFixed(2)),
      overallTotal: Number(overallTotal.toFixed(2)),
    };
  };

  const [billSummary, setBillSummary] = useState(calculateBillSummary());

  useEffect(() => {
    setBillSummary(calculateBillSummary());
  }, [cart, subTArray]);

  function deepEqual(obj1, obj2) {
    if (obj1 === obj2) {
      return true;
    }

    if (
      typeof obj1 !== "object" ||
      obj1 === null ||
      typeof obj2 !== "object" ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  /**************************** tax & disc management ****************************/

  // Update this useEffect to handle cart calculations properly:
  useEffect(() => {
    const updatedCart = cart.map((item, index) => ({
      ...item,
      discount: item.discount || 0,
      discountPercentage: item.discountPercentage || 0,
      amount: calculateAmount(item, selectedUnits[index]),
      taxAmount: calculateTax(item, item.selectedUnit, index),
      subT: subTArray[index] || 0,
    }));

    // Only update if there are actual changes
    if (!deepEqual(updatedCart, cart)) {
      dispatch(setCart(updatedCart));
    }
  }, [cart, subTArray, dispatch, selectedUnits]);

  const handleDiscountChange = (index, type, value) => {
    const updatedCart = cart.map((item, idx) => {
      if (idx === index) {
        let updatedItem = { ...item };

        if (value && value != "0") {
          value = value.startsWith("0") ? value.slice(1) : value;
        }

        if (value == "" || value == null || isNaN(value)) {
          value = "0";
        }

        if (type == "percentage") {
          updatedItem.discountPercentage = value;
          updatedItem.discount = calculateDiscount(updatedItem, selectedUnits[index]);
        } else if (type == "amount") {
          updatedItem.discount = value;
          updatedItem.discountPercentage = calculateDiscountPercentage(
            updatedItem,
            selectedUnits[index]
          );
        }
        updatedItem.amount = calculateAmount(updatedItem, selectedUnits[index]);
        return updatedItem;
      }
      return item;
    });

    dispatch(setCart(updatedCart));
  };

  const calculateDiscount = (row, selectedUnit) => {
    const subtotal = calculateSubT(row, selectedUnit);
    return (
      ((subtotal * parseFloat(row.discountPercentage)) / 100).toFixed(2) || 0
    );
  };

  const calculateDiscountPercentage = (row, selectedUnits) => {
    const subtotal = calculateSubT(row, selectedUnits);

    if (subtotal === 0) {
      return 0;
    }

    return ((parseFloat(row.discount) * 100) / subtotal).toFixed(2) || 0;
  };

  const calculateAmount = (item, selectedunit) => {
    const subtotal = calculateSubT(item, selectedunit);
    const discount = calculateDiscount(item, selectedunit);
    const validDiscount = !isNaN(discount) ? discount : 0;
    const tax = (subtotal * item.taxPercentage) / 100;
    const discountedSubtotal = subtotal - validDiscount;
    const total = discountedSubtotal + tax;

    return !isNaN(total) ? total.toFixed(2) : "0.00";
  };

  const Insertinvoicedata = async (data) => {
    dispatch(setSaveBtn(true));

    if (cart.length === 0) {
      toast.error("Please Select at least One Product.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      dispatch(setSaveBtn(false));
      return;
    }

    const invalidProducts = cart.filter((product) => product.quantity <= 0);

    if (invalidProducts.length > 0) {
      dispatch(setShowQtyRed(true));
      const errorMessage = `Quantity should be greater than 0 for the following product(s): ${invalidProducts
        .map((product) => product.name)
        .join(", ")}`;

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      dispatch(setSaveBtn(false));
      return;
    }

    try {
      const res = await axios.post(
        baseurl + "/expo_access_api/insertInvoiceData/",
        {
          AUTHORIZEKEY: AUTHORIZE_KEY,
          invoice_amount: billSummary?.actualTotalPrice,
          invoice_discount: billSummary?.totalDiscount,
          invoice_tax: billSummary?.totalTaxes,
          grand_total: billSummary?.overallTotal,
          contact_id: contact_id || "",
          biiling_addres_id: Billingaddress_id,
          shipping_addres_id: Shippingaddress_id,
          products: cart,
          company_id: selectedCompany,
          branch_id: selectedBranch,
        }
      );

      if (res && res?.data && res?.data[0]?.DATA) {
        dispatch(setInvoiceDetails({
          invoiceNo: res?.data[0]?.DATA,
          invoiceFullNo: res?.data[0]?.fullinvoice_no
        }));

        toast.success(res?.data[0]?.MSG, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        dispatch(setShowQtyRed(false));
        dispatch(setSaveBtn(true));
        dispatch(setPrintBtn(false));
        dispatch(setWhatsappBtn(false));
        dispatch(setIsInvoiceSaved(true));
      } else {
        dispatch(setShowQtyRed(false));
        toast.error(res?.data[0]?.MSG, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        dispatch(setSaveBtn(false));
        dispatch(setPrintBtn(false));
        dispatch(setWhatsappBtn(false));
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      dispatch(setSaveBtn(false));
      dispatch(setShowQtyRed(false));
    }
  };

  const fetchProductsForMainCategory = async (item, index) => {
    setIsSelected(index);
    setProductinfo("Data Found");
    setDisplayFilteredItems([]);
    if (item?.Children?.length > 0) {
      setCategoryData(item?.Children);
      setCategoryinfo("Data Found");
    } else {
      setCategoryinfo("Data Not Found");
      setCategoryData([]);
    }

    try {
      const response = await axios.post(
        "/ecommerce_api/getCategorywiseProductList/",
        {
          category_name: item?.name,
        }
      );

      if (response.data[0].STATUS == "SUCCESS") {
        const data = response.data[0]?.DATA;
        const fetchedItems = data ? data.products : [];
        setCategoryProducts(fetchedItems);
        setDisplayFilteredItems(fetchedItems);
        setProductinfo("Data Found");
        setIsSelected(index);
      } else {
        console.error("Error fetching data:", response.data[0].MSG);
        setAllProducts([]);
        setCategoryProducts([]);
        setDisplayFilteredItems([]);
        setProductinfo("Data Not Found");
        setIsSelected(index);
      }
    } catch (error) {
      console.error("Error in getCategorywiseProductList API:", error);
      setCategoryProducts([]);
      setDisplayFilteredItems([]);
      setProductinfo("Data Not Found");
    } finally {
      setLoading(false);
    }
  };

  const handleClickAll = async () => {
    if (isInvoiceSaved) {
      toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    try {
      await fetchSubcategoriesforAllbutton();
      await fetchAllProductsforAllbutton();
    } catch (error) {
      console.error("Error in handleClickAll:", error);
    }
  };

  const fetchSubcategoriesforAllbutton = async () => {
    setCategoryData([]);
    setCategoryinfo("Data found");
    try {
      const response = await axios.post(
        "/ecommerce_api/getProductCategoryList/",
        {
          tree: false,
          AUTHORIZEKEY: AUTHORIZE_KEY,
          PHPTOKEN: localStorage.getItem("id_token"),
        }
      );

      if (response.data[0].STATUS === "SUCCESS") {
        setCategoryData(response.data[0].DATA.categorylist);
        setCategoryinfo("Data found");
      } else {
        setCategoryData([]);
        setCategoryinfo("Data not found");
      }
    } catch (error) {
      console.error("Error in getProductCategoryList API:", error);
    }
  };

  const fetchAllProductsforAllbutton = async () => {
    setProductinfo("Data Found");
    setDisplayFilteredItems([]);
    try {
      const response = await axios.post(
        "/ecommerce_api/getCategorywiseProductList/",
        {
          category_name: "ALL",
        }
      );

      if (response.data[0].STATUS === "SUCCESS") {
        const data = response.data[0]?.DATA;
        const filteredItems = data ? data.products : [];

        if (filteredItems && filteredItems.length > 0) {
          setAllProducts(filteredItems);
          setCategoryProducts(filteredItems);
          setDisplayFilteredItems(filteredItems);
          setProductinfo("Data Found");
        } else {
          setProductinfo("Data not Found");
          setAllProducts([]);
          setCategoryProducts([]);
          setDisplayFilteredItems([]);
        }
      } else {
        console.error("Error fetching data:", response.data[0].MSG);
      }
    } catch (error) {
      console.error("Error in getCategorywiseProductList API:", error);
      setCategoryProducts([]);
      setDisplayFilteredItems([]);
      setProductinfo("Data Not Found");
    } finally {
      setLoading(false);
    }
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      const element = componentRef.current;
      if (element) {
        element.style.visibility = "visible";
        element.style.position = "relative";
        element.style.left = "0";
        element.style.marginTop = "20px";
      }
      return Promise.resolve();
    },
    onAfterPrint: () => {
      const element = componentRef.current;
      if (element) {
        element.style.visibility = "hidden";
        element.style.position = "absolute";
        element.style.left = "-9999px";
      }
      dispatch(setPrintBtn(false));
    },
  });

  const currenttodaydate = moment().format("DD-MM-YYYY");
  const [showgeneratetext, setShowgeneratetext] = useState(false);

  // Add beforeunload warning
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (cart.length > 0 && !isInvoiceSaved) {
        e.preventDefault();
        e.returnValue = 'You have unsaved items in your cart. Are you sure you want to leave?';
        return e.returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [cart.length, isInvoiceSaved]);

  return (
    <>
      <div className="mt-4 mx-2">
        {/* navbar start */}
        {MaincategoryData.length > 0 && (
          <nav className="navbar-pos">
            <ul className="navbar-nav-pos">
              <li
                className={`dropdown-item-pos ${selectedMaincategory == "ALL" ? "selected-item" : ""
                  }`}
                key="all"
                onClick={() => {
                  if (isInvoiceSaved) {
                    toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                    });
                    return;
                  }
                  dispatch(setSelectedMaincategory("ALL"));
                  handleClickAll();
                }}
              >
                ALL
              </li>
              {MaincategoryData.slice(0, 7).map((item, index) => {
                return (
                  <li
                    key={`maincat-${item.ID}`}
                    className={`dropdown-item-pos ${selectedMaincategory == item?.name ? "selected-item" : ""
                      }`}
                    onClick={() => {
                      if (isInvoiceSaved) {
                        toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                        });
                        return;
                      }
                      dispatch(setSelectedMaincategory(item?.name));
                      fetchProductsForMainCategory(item, index);
                    }}
                  >
                    {item?.name}
                  </li>
                );
              })}
              {MaincategoryData.length > 7 && (
                <li
                  key="more"
                  className={`nav-item dropdown-more dropdown-item-pos ${selectedMaincategory == "More" ? "selected-item" : ""
                    }`}
                  onClick={() => {
                    if (isInvoiceSaved) {
                      toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                      });
                      return;
                    }
                    handleMoreClick();
                  }}
                >
                  <button className="dropdown-toggle">More</button>
                  {showMore && (
                    <div className="dropdown-content">
                      <ul>
                        {MaincategoryData.slice(7).map((item, index) => (
                          <React.Fragment key={index}>
                            <li
                              key={`moreitem-${item.ID}`}
                              onClick={() => {
                                if (isInvoiceSaved) {
                                  toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                  });
                                  return;
                                }
                                fetchProductsForMainCategory(item, index);
                              }}
                            >
                              {item.name}
                            </li>
                            {index < MaincategoryData.slice(7).length - 1 && (
                              <hr className="more-horizontal" />
                            )}
                          </React.Fragment>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              )}
            </ul>
          </nav>
        )}

        {/* navbar end  */}
        <div className="pos-category-toggle-bar">
          <button
            type="button"
            className="btn btn-success pos-category-toggle-btn"
            onClick={() => setIsCategoryPanelOpen(true)}
          >
            Categories
          </button>
        </div>

        {isCategoryPanelOpen && (
          <div
            className="pos-category-overlay"
            onClick={() => setIsCategoryPanelOpen(false)}
          ></div>
        )}
        <Row className="my-grid mt-2 pos-main-grid">
          <Col
            className={`${categoriesToDisplay.length < 12
              ? " vertical-line"
              : "overflow-y-auto custom-scrollbar"
              } pos-category-col pos-category-drawer ${isCategoryPanelOpen ? "open" : ""}`}
          >
            <div className="pos-category-drawer-header">
              <strong>Categories</strong>
              <button
                type="button"
                className="btn btn-link p-0"
                onClick={() => setIsCategoryPanelOpen(false)}
              >
                Close
              </button>
            </div>
            <Form className="mt-1">
              <FormGroup
                className="m-0 form-group"
              >
                <div className="productSearchInputGroup">
                  <Input
                    className="form-control"
                    type="text"
                    placeholder="search categories..."
                    value={categorySearchQuery}
                    onChange={handleCategorySearchChange}
                    disabled={isInvoiceSaved}
                    style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
                  />
                </div>
              </FormGroup>
            </Form>
            <div className="mt-2 pos-categories-wrap">
                {category_info == "Data Not Found" &&
                  categoriesToDisplay.length == 0 ? (
                  <div className="center-nocategory vertical-line">
                    No categories found
                  </div>
                ) : null}
                {categoriesToDisplay && categoriesToDisplay.length > 0
                  ? categoriesToDisplay.map((item) => (
                    <div
                      id="cat-gridId"
                      className={`cat-gridId ${selectedCategory == item.name ? "selected" : ""
                        } d-flex-row hoverable`}
                      key={item.ID}
                      onClick={() => {
                        if (isInvoiceSaved) {
                          toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                          });
                          return;
                        }
                        handleCategoryClick(item.name);
                        setIsCategoryPanelOpen(false);
                      }}
                    >
                      <img
                        src={
                          item.full_image_path
                            ? item.full_image_path
                            : "https://hyc.ondemandcrm.co/public/images/ecommerce/productnotfound.png"
                        }
                        alt={item.name}
                        className="cat-img"
                        style={{ marginLeft: "2px" }}
                      />
                      <div className="categoryItemContainer">
                        <p
                          className={`category-name ${selectedCategory === item.name ? "selected" : ""
                            } `}
                        >
                          {item.name}
                        </p>
                      </div>
                    </div>
                  ))
                  : null}
                {category_info != "Data Not Found" &&
                  categoriesToDisplay.length == 0 && (
                    <div className="text-center mt-3">
                      <Spinner animation="border" variant="success" />
                    </div>
                  )}
            </div>
          </Col>

          {/* Product display */}
          <Col
            className={`${displayFilteredItems.length > 12
              ? " overflow-y-auto custom-scrollbar "
              : "vertical-line"
              } pos-product-col`}
          >
            <div className=" d-flex-col">
              <Form className="mt-1">
                <FormGroup
                  className="m-0 form-group search-product"
                >
                  <div className="productSearchInputGroup">
                    <Input
                      className="form-control"
                      type="text"
                      placeholder="search products..."
                      value={searchQuery}
                      onChange={(e) => {
                        dispatch(setSearchQuery(e.target.value));
                      }}
                      disabled={isInvoiceSaved}
                      style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
                    />

                    <i
                      className="fa fa-search"
                      onClick={() => {
                        if (isInvoiceSaved) {
                          toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                          });
                          return;
                        }
                      }}
                    ></i>
                  </div>
                </FormGroup>
              </Form>
              <div className="d-flex flex-wrap mt-2 pos-products-wrap">
                {product_info == "Data Not Found" &&
                  displayFilteredItems.length == 0 ? (
                  <div
                    className="loaderContainer d-flex-col vertical-line"
                    style={{ minHeight: "70vh" }}
                  >
                    No products found
                  </div>
                ) : null}
                {displayFilteredItems && displayFilteredItems.length > 0
                  ? displayFilteredItems.map((item, index) => {
                    const listPrice =
                      item.price1_min != null && item.price1_min !== ""
                        ? Number(item.price1_min)
                        : null;
                    const priceLabel =
                      listPrice != null && !Number.isNaN(listPrice)
                        ? `₹${listPrice.toFixed(2)}`
                        : "—";

                    const addProductToCart = (e) => {
                      if (e?.stopPropagation) e.stopPropagation();
                      if (isInvoiceSaved) {
                        toast.error(
                          "Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.",
                          {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                          }
                        );
                        return;
                      }
                      Openatrributemodal(
                        item,
                        item.product_id,
                        item?.name,
                        index
                      );
                    };

                    return (
                      <div
                        className="product-img d-flex-col hoverable pos-product-card"
                        key={item.product_id}
                      >
                        <Image
                          attrImage={{
                            className: "img-fluid prod-img",
                            src: item?.original_photo_path
                              ? item.original_photo_path
                              : "https://hyc.ondemandcrm.co/public/images/ecommerce/productnotfound.png",
                            alt: item?.name || "",
                          }}
                        />

                        <p className="product-name">{item.name}</p>
                        <p className="pos-product-price">{priceLabel}</p>
                        <button
                          type="button"
                          className="btn btn-success pos-product-add-btn"
                          onClick={addProductToCart}
                          disabled={isInvoiceSaved}
                          aria-label={`Add ${item.name} to cart`}
                        >
                          <FiShoppingCart className="me-1 bill-button-svg" />
                          Add to cart
                        </button>
                      </div>
                    );
                  })
                  : null}
                {product_info != "Data Not Found" &&
                  displayFilteredItems.length == 0 ? (
                  <div className="loaderContainer d-flex-col">
                    <Spinner animation="border" variant="success" />
                  </div>
                ) : null}
              </div>
            </div>
          </Col>

          {/* Product qty portion discount portion */}
          <Col className="pos-right-col">
            <div className="d-flex-col">
              <div className="rightMenu d-flex-col">
                <Row className="pos-customer-toggle-row">
                  {addCustomerDetails && showBillingModal && (
                    <Col md={12}>
                      <div className="shippingCheckboxContainer d-flex-row">
                        <label htmlFor="shippingCheckbox">
                          Shipping Same as Billing
                        </label>
                        <input
                          type="checkbox"
                          id="shippingCheckbox"
                          name="shippingCheckbox"
                          checked={sameAsBilling}
                          onChange={handleCheckboxChange}
                          disabled={isInvoiceSaved}
                          style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                        />
                      </div>
                    </Col>
                  )}
                  <Col md={12} className="customerdetail-switch mt-1">
                    <div className="form-check form-switch cust-toggle-line d-flex-row">
                      <label
                        className="form-check-label"
                        htmlFor="toggleSwitch"
                      >
                        <MdContactPhone className="contact-icon me-1" />
                        Add Customer Details
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="toggleSwitch"
                        checked={addCustomerDetails}
                        onChange={handleCustomerDetailsToggle}
                        disabled={isInvoiceSaved}
                        style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                      />
                    </div>
                  </Col>
                </Row>

                {addCustomerDetails && (
                  <>
                    <Row className="pos-contact-address-row">
                      <Col md={6}>
                        <Row>
                          <Col md={10} style={{ paddingRight: "0px" }}>
                            <div className="d-flex-col">
                              <ReactSelect
                                options={contacts
                                  .filter((contact) => contact.name)
                                  .map((contact) => ({
                                    value: contact.id,
                                    label: `${contact.name} - ${contact.mobile}`,
                                    email: contact.email,
                                    mobile: contact.mobile,
                                    contactname: contact.name,
                                  }))}
                                components={animatedComponents}
                                menuPortalTarget={document.body}
                                value={
                                  selectedContact
                                    ? {
                                      value: selectedContact.id,
                                      label: `${selectedContact.name} - ${selectedContact.mobile}`,
                                    }
                                    : null
                                }
                                onChange={(selectedOption) => {
                                  handleSelectChange(selectedOption);
                                }}
                                isDisabled={isInvoiceSaved}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    cursor: isInvoiceSaved ? 'not-allowed' : 'pointer',
                                    opacity: isInvoiceSaved ? 0.75 : 1,
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    cursor: isInvoiceSaved ? 'not-allowed' : 'pointer',
                                    opacity: isInvoiceSaved ? 0.75 : 1,
                                  }),
                                }}
                              />

                              <div className="d-flex contact-group mt-1">
                                <p className="contact-p">Contact</p>
                              </div>
                            </div>
                          </Col>
                          <Col md={2}>
                            <Button
                              variant="primary"
                              className="mt-2 p-1 btn-sm d-flex align-items-center contact-button"
                              onClick={togglecontact}
                              disabled={isInvoiceSaved}
                              style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                            >
                              <AiOutlinePlus size={15} />
                            </Button>
                          </Col>
                        </Row>
                      </Col>

                      {showBillingModal && (
                      <Col md={6}>
                        {
                          <>
                            <Row>
                              <Col md={10} style={{ paddingRight: "0px" }}>
                                <div className="d-flex-col">
                                  <select
                                    className="form-select form-control form-control-sm"
                                    id="sel_address"
                                    name="sel_address"
                                    value={Billingaddress_id || ""}
                                    onChange={(e) =>
                                      dispatch(setAddressDetails({
                                        billingAddressId: e.target.value,
                                        // ✅ KEY FIX: if sameAsBilling, shipping always follows billing
                                        shippingAddressId: sameAsBilling ? e.target.value : Shippingaddress_id,
                                        sameAsBilling,
                                      }))
                                    }
                                    disabled={isInvoiceSaved}
                                    style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                                  >
                                    <option value="">-- Select Billing Address --</option>
                                    {Address.map((option) => (
                                      <option key={option.address_id} value={option.address_id}>
                                        {option.address_1 ? option.address_1.slice(0, 25) : "No Address found"}
                                      </option>
                                    ))}
                                  </select>

                                  <div className="d-flex billing-group mt-1">
                                    <p className="billing-p">Billing address</p>
                                  </div>
                                </div>
                              </Col>
                              <Col md={2}>
                                <div>
                                  <Button
                                    variant="primary"
                                    className="mt-2 p-1 btn-sm d-flex align-items-center billing-button"
                                    onClick={togglebilling}
                                    disabled={isInvoiceSaved}
                                    style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                                  >
                                    <AiOutlinePlus size={15} />
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </>
                        }
                      </Col>
                      )}

                      {showShippingModal && (
                      <Col md={6}>
                        {
                          <>
                            <Row>
                              <Col md={10} style={{ paddingRight: "0px" }}>
                                <div className="d-flex-col">
                                  <Form.Select
                                    aria-label="Second select example"
                                    value={Shippingaddress_id || ""}
                                    onChange={(e) =>
                                      dispatch(setAddressDetails({
                                        billingAddressId: Billingaddress_id,
                                        shippingAddressId: e.target.value,
                                        sameAsBilling,
                                      }))
                                    }
                                    disabled={isInvoiceSaved}
                                    style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                                  >
                                    {Address.map((option) => (
                                      <option
                                        key={option.address_id}
                                        value={option.address_id}
                                      >
                                        {option.address_1
                                          ? option.address_1.slice(0, 25)
                                          : "No Address found"}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  <div className="shipping-group d-flex-row mt-1">
                                    <p className="shipping-p">
                                      Shipping address
                                    </p>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </>
                        }
                      </Col>
                      )}
                    </Row>
                  </>
                )}

                <Row className="pos-top-controls-row">
                  <Col md={6}>
                    <div className="d-flex-col">
                      <Form.Select
                        aria-label="Select company"
                        value={selectedCompany || ""}
                        className="select-company pos-top-select"
                        onChange={(e) => dispatch(setSelectedCompany(e.target.value))}
                        style={{ cursor: "pointer" }}
                      >
                        {!Array.isArray(company_arr) || company_arr.length === 0 ? (
                          <option value="">No company found</option>
                        ) : null}
                        {Array.isArray(company_arr) &&
                          company_arr.length > 0 &&
                          company_arr.map((cr, j) => {
                            const companyId = cr?.company_id ?? cr?.id ?? "";
                            const companyName = cr?.name ?? cr?.company_name ?? cr?.company ?? `Company ${j + 1}`;
                            return (
                              <option value={companyId} key={companyId || j}>
                                {companyName}
                              </option>
                            );
                          })}
                      </Form.Select>
                      <div className="shipping-group d-flex-row mt-1">
                        <p className="shipping-p">Company</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex-col">
                      <Form.Select
                        aria-label="Select branch"
                        value={selectedBranch || ""}
                        className="pos-top-select"
                        onChange={(e) => dispatch(setSelectedBranch(e.target.value))}
                        style={{ cursor: "pointer" }}
                      >
                        {!Array.isArray(branch_arr) || branch_arr.length === 0 ? (
                          <option value="">No branch found</option>
                        ) : null}
                        {Array.isArray(branch_arr) &&
                          branch_arr.length > 0 &&
                          branch_arr.map((br, i) => {
                            const branchId = br?.branch_id ?? br?.id ?? "";
                            const branchName = br?.name ?? br?.branch_name ?? br?.branch ?? `Branch ${i + 1}`;
                            return (
                              <option value={branchId} key={branchId || i}>
                                {branchName}
                              </option>
                            );
                          })}
                      </Form.Select>
                      <div className="shipping-group d-flex-row mt-1">
                        <p className="shipping-p">Branch</p>
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3 pos-barcode-row">
                  <Col md={12}>
                    <Form className="mt-1">
                      <FormGroup
                        className="m-0 form-group search-product"
                      >
                        <div className="productSearchInputGroup barcode-input">
                          <Input
                            className="form-control pos-top-input"
                            type="text"
                            placeholder="search barcode..."
                            value={searchBarcode}
                            onChange={(e) => {
                              dispatch(setSearchBarcode(e.target.value));
                            }}
                            disabled={isInvoiceSaved}
                            style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'text', opacity: isInvoiceSaved ? 0.75 : 1 }}
                          />

                          <i
                            className="fa fa-search"
                            onClick={() => {
                              if (isInvoiceSaved) {
                                toast.error("Invoice already saved. You can print this invoice or share it on WhatsApp. To create a new invoice, click 'New'.", {
                                  position: "top-right",
                                  autoClose: 5000,
                                  hideProgressBar: false,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                });
                                return;
                              }
                            }}
                          ></i>
                        </div>
                      </FormGroup>
                    </Form>
                  </Col>
                </Row>

                {/* draft code */}

                <Modal
                  isOpen={isOpen}
                  toggle={() => dispatch(toggleModal())}
                  className="draft-modal-lg"
                  size="xl"
                  backdrop="static"
                  keyboard={false}
                >
                  <ModalHeader toggle={() => dispatch(toggleModal())}>
                    All Draft Orders
                  </ModalHeader>
                  <ModalBody className="">
                    <Row className="gy-3 gx-3">
                      {drafts.length == 0 ? (
                        <p style={{ fontSize: "20px", fontWeight: "bolder" }}>
                          No draft orders available.
                        </p>
                      ) : (
                        drafts.map((draft) => (
                          <Col
                            key={draft.id}
                            md={3}
                            onClick={() => {
                              if (isInvoiceSaved) {
                                Swal.fire({
                                  title: "Invoice Already Saved",
                                  html: `
    <div style="text-align: left; font-size: 14px;">
      <p><strong>This invoice has already been saved.</strong></p>
      <p>You can perform the following actions:</p>
      <ul style="padding-left: 18px;">
        <li>🖨️ Print the invoice</li>
        <li>📲 Share the invoice on WhatsApp</li>
      </ul>
      <p style="margin-top: 10px;">
        To create a new invoice, please click the <strong>"New"</strong> button.
      </p>
    </div>
  `,
                                  icon: "info",
                                  confirmButtonText: "OK",
                                  confirmButtonColor: "#0d6efd",
                                  showCloseButton: true,
                                  focusConfirm: false,
                                });

                                return;
                              }
                              handleEdit(draft, drafts);
                            }}
                            style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer' }}
                          >
                            <div className="draftBox d-flex-col">
                              <p className="draftNumber mb-0">{`Draft #${drafts.indexOf(draft) + 1}`}</p>

                              <p className="draftDetails-p">
                                <span
                                  style={{ fontWeight: "bold", color: "black" }}
                                >{`Contact: `}</span>
                                {`${draft?.contactName && draft?.contactName}`}
                              </p>
                              <p
                                className="draftDetails-p "
                                style={{ fontWeight: "bold", color: "black" }}
                              >
                                {`Date and Time: `}
                              </p>
                              <p className="mb-0">
                                {`${draft?.currentDateAndTime}`}
                              </p>
                              <p className="draftDetails-p">
                                <span
                                  style={{ fontWeight: "bold", color: "black" }}
                                >{`Mobile No: `}</span>
                                {`${draft?.contactMobileNumber &&
                                  draft?.contactMobileNumber
                                  }`}
                              </p>
                              <p className="draftDetails-p">
                                <span
                                  style={{ fontWeight: "bold", color: "black" }}
                                >{`Total Products: `}</span>
                                {`${draft?.numberOfItems}`}
                              </p>

                              <p className="draftDetails-p">
                                <span
                                  style={{ fontWeight: "bold", color: "black" }}
                                >{`Total Quantity: `}</span>
                                {`${draft?.TotalQuantity}`}
                              </p>

                              <p className="draftDetails-p draft-total-amt">
                                {`Amount to Pay: `}
                              </p>
                              <p
                                style={{
                                  marginTop: "2px",
                                  fontSize: "large",
                                  fontWeight: "bold",
                                  color: "green",
                                }}
                                className="mb-0"
                              >
                                {`₹${parseFloat(draft.total).toFixed(2)}`}
                              </p>
                              <div className="d-flex justify-content-end">
                                <div>
                                  <Button
                                    className="modal-button"
                                    variant="info"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleEdit(draft, drafts);
                                    }}
                                    disabled={isInvoiceSaved}
                                    style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                                  >
                                    <FaEdit />
                                  </Button>
                                </div>
                                <div className="ms-2">
                                  <Button
                                    className="modal-button"
                                    variant="danger"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDelete(draft, drafts);
                                    }}
                                    disabled={isInvoiceSaved}
                                    style={{ cursor: isInvoiceSaved ? 'not-allowed' : 'pointer', opacity: isInvoiceSaved ? 0.75 : 1 }}
                                  >
                                    <RiDeleteBin7Fill />
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))
                      )}
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="secondary"
                      onClick={() => dispatch(toggleModal())}
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              </div>
              <div className="billContainer d-flex-col pos-bill-panel">
                <div className="billContainerBody d-flex-col">
                  <div className="bill">
                    {cart_info == "Data not found" && cart.length == 0 ? (
                      <div
                        className="text-center mt-3 py-3"
                        style={{ backgroundColor: "#dfdcdc" }}
                      >
                        There are no records to display
                      </div>
                    ) : cart_loading ? (
                      <div className="text-center pt-3 pb-2">
                        <Spinner animation="border" variant="success" />
                      </div>
                    ) : (
                      <>
                        <div className="pos-cart-table-desktop">
                          <DataTable
                            noHeader
                            paginationServer
                            columns={productColumns}
                            data={cart}
                            highlightOnHover={true}
                            striped={true}
                            responsive={true}
                            persistTableHead={true}
                          />
                        </div>
                        <div className="pos-cart-accordion-mobile">
                          {cart.map((row, index) => {
                            const isOpen = activeCartCardIndex === index;
                            return (
                              <div className="pos-cart-card" key={`${row.product_id}-${index}`}>
                                <button
                                  type="button"
                                  className="pos-cart-card-header"
                                  onClick={() => setActiveCartCardIndex(isOpen ? null : index)}
                                >
                                  <div className="pos-cart-title-wrap">
                                    <img
                                      src={row.original_photo_path}
                                      alt={row.name}
                                      className="pos-cart-thumb"
                                    />
                                    <div>
                                      <p className="pos-cart-title">{row.name}</p>
                                      <p className="pos-cart-subtitle">
                                        Qty: {row.quantity} | Payable: Rs. {row.amount}
                                      </p>
                                    </div>
                                  </div>
                                  <span className="pos-cart-edit-btn">
                                    {isOpen ? "Close" : "Edit"}
                                  </span>
                                </button>

                                {isOpen && (
                                  <div className="pos-cart-card-body">
                                    <div className="pos-cart-grid">
                                      <div>
                                        <label>Unit</label>
                                        <Form.Select
                                          size="sm"
                                          value={row.selectedUnit || 1}
                                          onChange={(e) => handleUnitChange(index, e.target.value, row)}
                                          disabled={isInvoiceSaved}
                                        >
                                          {row.unit_name != "" && <option value="1">{row.unit_name}</option>}
                                          {row.second_unit != "" && <option value="2">{row.second_unit}</option>}
                                        </Form.Select>
                                      </div>

                                      <div>
                                        <label>Qty</label>
                                        <Form.Control
                                          type="number"
                                          size="sm"
                                          value={row.quantity.toString()}
                                          onChange={(e) => handleQuantityInputChange(index, e.target.value)}
                                          disabled={isInvoiceSaved}
                                        />
                                      </div>

                                      <div>
                                        <label>Rate</label>
                                        <Form.Control
                                          type="number"
                                          size="sm"
                                          value={row.mrp_price ? row.mrp_price.toString() : ""}
                                          onChange={(e) => handleChangeRate(index, e.target.value)}
                                          disabled={isInvoiceSaved}
                                        />
                                      </div>

                                      <div>
                                        <label>Disc (%)</label>
                                        <Form.Control
                                          type="text"
                                          size="sm"
                                          value={row.discountPercentage}
                                          onChange={(e) => handleDiscountChange(index, "percentage", e.target.value)}
                                          disabled={isInvoiceSaved}
                                        />
                                      </div>

                                      <div>
                                        <label>Disc</label>
                                        <Form.Control
                                          type="text"
                                          size="sm"
                                          value={row.discount}
                                          onChange={(e) => handleDiscountChange(index, "amount", e.target.value)}
                                          disabled={isInvoiceSaved}
                                        />
                                      </div>

                                      <div className="pos-cart-metrics">
                                        <p>Stock: {row.stock}</p>
                                        <p>Gross: {Number(subTArray[index] || 0).toFixed(2)}</p>
                                        <p>Tax ({row.taxPercentage}%): {calculateTax(row, selectedUnits[index], index)}</p>
                                      </div>
                                    </div>

                                    <div className="pos-cart-card-footer">
                                      <strong>Payable: Rs. {row.amount}</strong>
                                      <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={() => handleRemoveFromCart(row.product_id, index)}
                                        disabled={isInvoiceSaved}
                                      >
                                        <FiTrash className="me-1" />
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </>
                    )}
                  </div>
                </div>



                <div className="extraDetailsContainer d-flex-col">
                  <div className="resultContainer d-flex-row">
                    <table className="resultTable box">
                      <thead>
                        <tr>
                          <th colSpan="2">Bill Summary</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Total Products:</td>
                          <td>{billSummary.totalItems}</td>
                        </tr>
                        <tr style={{ borderBottom: "1px solid #ddd" }}>
                          <td>Total Gross Amount:</td>
                          <td>₹{billSummary.actualTotalPrice.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>Total Discount:</td>
                          <td>₹{billSummary.totalDiscount.toFixed(2)}</td>
                        </tr>
                        <tr style={{ borderBottom: "1px solid #ddd" }}>
                          <td>Total Taxes:</td>
                          <td>₹{billSummary.totalTaxes.toFixed(2)}</td>
                        </tr>
                        <tr style={{ borderBottom: "1px solid #ddd" }}>
                          <td>Total Payable Amount:</td>
                          <td
                            style={{
                              fontSize: "larger",
                              color: "green",
                              fontWeight: "500",
                            }}
                          >
                            ₹{billSummary.overallTotal.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {showgeneratetext && (
                    <div className="text-center timesheet-label mt-3">
                      Please wait while sending message...
                    </div>
                  )}

                  {isInvoiceSaved && (
                    <div className="invoice-saved-notification d-flex-col text-center p-3 mt-3">
                      <div className="success-check mb-2">
                        <i className="fa fa-check-circle" style={{ fontSize: "2rem", color: "#28a745" }}></i>
                      </div>
                      <h5 className="text-success mb-2">Invoice Saved Successfully!</h5>
                      <p className="mb-1">
                        <strong>Invoice No:</strong> {Invoice_fullno}
                      </p>
                      <p className="mb-1">You can now print or share it on WhatsApp.</p>
                      <p className="mb-0 small text-muted">
                        To create a new invoice, click the <strong>"New"</strong> button.
                      </p>
                    </div>
                  )}

                  <div className="buttonsBillContainer d-flex-row">
                    <button
                      type="button"
                      className="btn btn-info new-btn buttonBill save d-flex-row"
                      // Update the New button onClick:
                      onClick={() => {
                        dispatch(resetForNewInvoice());

                        // Clear local states
                        setProductselectid("");
                        setAttrlabel([]);
                        setPricelistaarray([]);
                        setAddress([]);

                        // Reset company/branch to defaults
                        if (company_arr?.length > 0) {
                          dispatch(setSelectedCompany(company_arr[0].company_id));
                        }
                        if (branch_arr?.length > 0) {
                          dispatch(setSelectedBranch(branch_arr[0].branch_id));
                        }

                        setCartinfo("Data not found");
                      }}
                    >
                      <div className="svgButtonContainer d-flex-row">
                        <MdCreateNewFolder
                          className="bill-button-svg"
                          size={20}
                        />
                      </div>
                      <span className="bill-button-text">New</span>
                    </button>

                    <button
                      type="button"
                      className="draft-button-group btn btn-warning buttonBill draft d-flex-row"
                      // Update the Draft button onClick:
                      // In the Draft button onClick:
                      onClick={() => {
                        if (cart.length > 0) {
                          const total = cart.reduce(
                            (acc, item) => acc + parseFloat(item.amount),
                            0
                          );

                          const totalQuantity = cart.reduce((acc, item) => {
                            return acc + item.quantity;
                          }, 0);

                          const newDraft = {
                            id: Date.now(),
                            items: [...cart],
                            numberOfItems: cart?.length,
                            contactName: addCustomerDetails && contact_name != "" ? contact_name : "",
                            contactMobileNumber: addCustomerDetails && contact_number != "" ? contact_number : "",
                            contactid: addCustomerDetails && contact_id != "" ? contact_id : "",
                            BillingaddressId: Billingaddress_id,
                            ShippingaddressId: Shippingaddress_id,
                            Ship_Bill_Same: sameAsBilling, // ✅ Save the current checkbox state
                            total: total,
                            currentDateAndTime: moment().format("MMMM Do YYYY, h:mm:ss a"),
                            TotalQuantity: totalQuantity,
                          };

                          addDraft(newDraft);

                          // Reset all state
                          dispatch(resetForNewInvoice());

                          // Clear local states
                          setAddress([]);
                          setProductselectid("");
                          setAttrlabel([]);
                          setPricelistaarray([]);
                          setCartinfo("Data not found");
                        } else {
                          toast.error("Please Select Product", {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                          });
                        }
                      }}
                      disabled={Savebtn}
                      style={{ cursor: Savebtn ? 'not-allowed' : 'pointer', opacity: Savebtn ? 0.75 : 1 }}
                    >
                      <div className="svgButtonContainer d-flex-row">
                        <MdDrafts className="bill-button-svg" size={20} />
                      </div>
                      <span className="bill-button-text">Draft</span>
                    </button>

                    <button
                      type="button"
                      className="save-button-group btn btn-success buttonBill save d-flex-row"
                      onClick={() => Insertinvoicedata()}
                      disabled={Savebtn}
                      style={{ cursor: Savebtn ? 'not-allowed' : 'pointer', opacity: Savebtn ? 0.75 : 1 }}
                    >
                      <div className="svgButtonContainer d-flex-row">
                        <FaSave className="bill-button-svg" size={20} />
                      </div>
                      <span className="bill-button-text">Save</span>
                    </button>

                    <button
                      type="button"
                      className="print-button-group btn btn-gradient buttonBill save d-flex-row"
                      onClick={() => {
                        handlePrint();
                        dispatch(setPrintBtn(true));
                      }}
                      disabled={Printbtn}
                      style={{ cursor: Printbtn ? 'not-allowed' : 'pointer', opacity: Printbtn ? 0.75 : 1 }}
                    >
                      <div className="svgButtonContainer d-flex-row">
                        <FaPrint className="bill-button-svg" size={20} />
                      </div>
                      <span className="bill-button-text">Print</span>
                    </button>

                    <div className="d-flex flex-column">
                      <button
                        type="button"
                        className="whatsapp-button-group btn btn-success buttonBill save d-flex-row"
                        onClick={() => {
                          generatePDF();
                          dispatch(setWhatsappBtn(true));
                          setShowgeneratetext(true);
                        }}
                        disabled={whatsappbtn}
                        style={{ cursor: whatsappbtn ? 'not-allowed' : 'pointer', opacity: whatsappbtn ? 0.75 : 1 }}
                      >
                        <div className="svgButtonContainer d-flex-row">
                          <FaWhatsapp className="bill-button-svg" size={23} />
                        </div>
                        <span className="bill-button-text">Whatsapp</span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* invoice pdf view start  */}
                <div>
                  <div
                    className="d-flex justify-content-center align-items-center "
                    ref={componentRef}
                    id="rep1"
                    style={{
                      width: "210mm",
                      minHeight: "auto",
                      padding: "20px",
                      backgroundColor: "white",
                      boxSizing: "border-box",
                      visibility: "hidden",
                      position: "absolute",
                      "@media print": {
                        visibility: "visible",
                        position: "relative",
                        left: "0",
                      },
                    }}
                  >
                    <div
                      className="receipt"
                      style={{ width: "100%", height: "100%" }}
                    >
                      <div className="text-center">
                        <img
                          className="img-fluid for-light my-2"
                          src={`${baseurl}${image_url_logo}`}
                          alt="company_logo"
                        />
                      </div>
                      <p>
                        <b>Name: </b>
                        {contact_name || "Cash Contact"}
                      </p>
                      <p>
                        <b>Mobile: </b>
                        {contact_number || "9824023886"}
                      </p>
                      <hr className="my-2" />
                      <p>
                        <b>Invoice No: </b>
                        {Invoice_fullno}
                      </p>
                      <p>
                        <b>Date: </b>
                        {currenttodaydate}
                      </p>
                      <hr className="my-2" />
                      <table>
                        <thead>
                          <tr>
                            <th>Item</th>
                            <th>Qty</th>
                            <th>Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cart?.length > 0 &&
                            cart?.map((item) => (
                              <tr key={item.product_id}>
                                <td>{item.name}</td>
                                <td>{item.quantity}</td>
                                <td>
                                  <span className="inr-font">INR </span>
                                  {item?.subT?.toFixed(2)}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colSpan="2">Total Groos Amount</th>
                            <td>
                              <span className="inr-font">INR </span>
                              {billSummary?.actualTotalPrice}
                            </td>
                          </tr>
                          <tr>
                            <th colSpan="2">Total Discount Amount</th>
                            <td>
                              <span className="inr-font">INR </span>
                              {billSummary?.totalDiscount}
                            </td>
                          </tr>
                          <tr>
                            <th colSpan="2">Total Taxes Amount</th>
                            <td>
                              <span className="inr-font">INR </span>
                              {billSummary?.totalTaxes}
                            </td>
                          </tr>
                          <tr>
                            <th colSpan="2">Total Payable Amount</th>
                            <td>
                              <span className="inr-font">INR </span>
                              {(
                                billSummary?.actualTotalPrice -
                                billSummary?.totalDiscount +
                                billSummary?.totalTaxes
                              )?.toFixed(2)}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                      <hr className="my-2" />
                      <p>Thank you for your business!</p>
                    </div>
                  </div>
                </div>
                {/* invoice pdf  view end  */}

                {/* Contact name  */}
                <Modal
                  isOpen={contactmodal}
                  toggle={togglecontact}
                  size="lg"
                  backdrop="static"
                  keyboard={false}
                >
                  <ModalHeader toggle={togglecontact}>Contact name</ModalHeader>
                  <Form onSubmit={handleSubmit(handleSubmitContact)}>
                    <ModalBody className="grid-showcase">
                      <Container fluid={true} className="bd-example-row">
                        <Row className="mb-3">
                          <Col xs={4} md={4}>
                            <Form.Group>
                              <Form.Label>
                                <b>Name</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Name"
                                id="name"
                                name="name"
                                {...register("name", {
                                  required: true,
                                  maxLength: 30,
                                })}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={4} md={4}>
                            <Form.Group>
                              <Form.Label>
                                <b>Mobile No</b>
                              </Form.Label>
                              <Form.Control
                                type="tel"
                                placeholder="Enter Mobile Number"
                                id="mobile"
                                name="mobile"
                                {...register("mobile", {
                                  required: "Mobile number is required",
                                  pattern: {
                                    value: /^[0-9]{10}$/,
                                    message:
                                      "Enter a valid 10-digit mobile number",
                                  },
                                })}
                                minLength={10}
                                maxLength={10}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={4} md={4}>
                            <Form.Group>
                              <Form.Label>
                                <b>Email</b>
                              </Form.Label>
                              <Form.Control
                                type="email"
                                placeholder="Enter email"
                                name="email"
                                {...register("email")}
                                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}"
                                title="Please enter a valid email address"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Address Line 1</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="address1"
                                {...register("address1")}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Address Line 2</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="address2"
                                {...register("address2")}
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={3} md={3}>
                            <Form.Group>
                              <Form.Label>
                                <b>Address Type</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="address_type"
                                {...register("address_type")}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={3} md={3}>
                            <Form.Group>
                              <Form.Label>
                                <b>Area</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="area"
                                {...register("area")}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={3} md={3}>
                            <Form.Group>
                              <Form.Label>
                                <b>City</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="city"
                                {...register("city")}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={3} md={3}>
                            <Form.Group>
                              <Form.Label>
                                <b>Pincode</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="zipcode"
                                {...register("zipcode")}
                                minLength={6}
                                maxLength={6}
                                onKeyDown={(e) => {
                                  if (
                                    !/[0-9]/.test(e.key) &&
                                    e.key != "Backspace"
                                  ) {
                                    e.preventDefault();
                                  }
                                  if (
                                    e.target.value.length >= 6 &&
                                    e.key != "Backspace"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group controlId="sel_country">
                              <Form.Label>
                                <b>Country</b>
                              </Form.Label>
                              <Form.Select
                                name="country"
                                {...register("country", { required: true })}
                                onChange={(e) => {
                                  changestate(e, 0);
                                }}
                              >
                                <option value=""> -- Select Country -- </option>
                                {country.map((cntry) => (
                                  <option
                                    key={cntry.Country.country_code}
                                    value={cntry.Country.country_name}
                                  >
                                    {cntry.Country.country_name}
                                  </option>
                                ))}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a country.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>State</b>
                              </Form.Label>
                              <Form.Select
                                name="state"
                                {...register("state", { required: true })}
                                onChange={(e) => {
                                  setAddContact({
                                    ...addcontact,
                                    state: e.target.value,
                                  });
                                }}
                              >
                                <option value=""> -- Select State -- </option>
                                {State
                                  ? [
                                    State.map((S) => (
                                      <option
                                        key={`state_${S.State.state_name}`}
                                        value={S.State.state_name}
                                      >
                                        {S.State.state_name}
                                      </option>
                                    )),
                                  ]
                                  : ""}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a state.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Container>
                    </ModalBody>
                    <ModalFooter>
                      <Btn
                        attrBtn={{ color: "secondary", onClick: togglecontact }}
                      >
                        Close
                      </Btn>
                      <Btn
                        attrBtn={{ color: "primary", disabled: contactbtn }}
                        type="submit"
                      >
                        Save Changes
                      </Btn>
                    </ModalFooter>
                  </Form>
                </Modal>

                {/* Billing address  */}
                <Modal
                  isOpen={billingmodal}
                  toggle={togglebilling}
                  size="lg"
                  backdrop="static"
                  keyboard={false}
                >
                  <ModalHeader toggle={togglebilling}>
                    Billing Address
                  </ModalHeader>
                  <Form onSubmit={(e) => handleSubmitAddressBilling(e)}>
                    {" "}
                    <ModalBody className="grid-showcase">
                      <Container fluid={true} className="bd-example-row">
                        <Row className="mb-3">
                          <Col xs={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Address Type</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_add_type_new_billing"
                                name="txt_add_type_new_billing"
                                value={nickname_billing}
                                onChange={handleChangeFieldbilling}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Address Line 1</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_add_new1_billing"
                                name="txt_add_new1_billing"
                                value={address1_billing}
                                onChange={handleChangeFieldbilling}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Addrss Line 2</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_add_new2_billing"
                                name="txt_add_new2_billing"
                                value={address2_billing}
                                onChange={handleChangeFieldbilling}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Area</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_area_new_billing"
                                name="txt_area_new_billing"
                                value={area_billing}
                                onChange={handleChangeFieldbilling}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>City</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_city_new_billing"
                                name="txt_city_new_billing"
                                value={city_billing}
                                onChange={handleChangeFieldbilling}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group controlId="sel_country_new">
                              <Form.Label>
                                <b>Country</b>
                              </Form.Label>
                              <Form.Select
                                id="sel_country_new_billing"
                                name="sel_country_new_billing"
                                onChange={(e) => {
                                  changestate(e, 0);
                                }}
                                value={selcountry_billing}
                                required
                              >
                                <option value=""> -- Select Country -- </option>
                                {country
                                  ? [
                                    country.map((C) => (
                                      <option
                                        key={`country_${C.Country.country_code}`}
                                        value={C.Country.country_name}
                                      >
                                        {C.Country.country_name}
                                      </option>
                                    )),
                                  ]
                                  : ""}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a country.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group controlId="sel_state_new">
                              <Form.Label>
                                <b>State</b>
                              </Form.Label>
                              <Form.Select
                                id="sel_state_new_billing"
                                name="sel_state_new_billing"
                                value={selstate_billing}
                                onChange={handleChangeFieldbilling}
                                required
                              >
                                <option value=""> -- Select State -- </option>
                                {State
                                  ? [
                                    State.map((S) => (
                                      <option
                                        key={`state_${S.State.state_name}`}
                                        value={S.State.state_name}
                                      >
                                        {S.State.state_name}
                                      </option>
                                    )),
                                  ]
                                  : ""}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a state.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Pincode</b>
                              </Form.Label>
                              <Form.Control
                                type="number"
                                id="txt_zipcode_new_billing"
                                name="txt_zipcode_new_billing"
                                value={zipcode_billing}
                                onChange={handleChangeFieldbilling}
                                maxLength={6}
                                onKeyDown={(e) => {
                                  if (
                                    e.target.value.length >= 6 &&
                                    e.key != "Backspace"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Container>
                    </ModalBody>
                    <ModalFooter>
                      <Btn
                        attrBtn={{ color: "secondary", onClick: togglebilling }}
                      >
                        Close
                      </Btn>
                      <Button color="primary" type="submit">
                        SaveChanges
                      </Button>
                    </ModalFooter>
                  </Form>
                </Modal>

                {/* Shipping address  */}
                <Modal
                  isOpen={shippingmodal}
                  toggle={toggleshipping}
                  size="lg"
                  backdrop="static"
                  keyboard={false}
                >
                  <ModalHeader toggle={toggleshipping}>
                    Shipping Address
                  </ModalHeader>
                  <Form onSubmit={(e) => handleSubmitAddressShipping(e)}>
                    <ModalBody className="grid-showcase">
                      <Container fluid={true} className="bd-example-row">
                        <Row className="mb-3">
                          <Col xs={12}>
                            <Form.Group>
                              <Form.Label>
                                <b>Address Type</b>
                              </Form.Label>
                              <Form.Control
                                as="textarea"
                                id="txt_add_type_new_shipping"
                                name="txt_add_type_new_shipping"
                                value={nickname_shipping}
                                onChange={handleChangeFieldShipping}
                                placeholder="Address"
                                required
                                rows={2}
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Address Line 1</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_add_new1_shipping"
                                name="txt_add_new1_shipping"
                                value={address1_shipping}
                                onChange={handleChangeFieldShipping}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Addrss Line 2</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_add_new2_shipping"
                                name="txt_add_new2_shipping"
                                value={address2_shipping}
                                onChange={handleChangeFieldShipping}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Area</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_area_new_shipping"
                                name="txt_area_new_shipping"
                                value={area_shipping}
                                onChange={handleChangeFieldShipping}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>City</b>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="txt_city_new_shipping"
                                name="txt_city_new_shipping"
                                value={city_shipping}
                                onChange={handleChangeFieldShipping}
                                onKeyDown={(e) => {
                                  if (/\d/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col xs={6} md={6}>
                            <Form.Group controlId="sel_country">
                              <Form.Label>
                                <b>Country</b>
                              </Form.Label>
                              <Form.Select
                                id="sel_country_shipping"
                                name="sel_country_shipping"
                                onChange={(e) => {
                                  changestate(e, 0);
                                }}
                                value={selcountry_shipping}
                                required
                              >
                                <option value=""> -- Select Country -- </option>
                                {country
                                  ? [
                                    country.map((C) => (
                                      <option
                                        key={`country_${C.Country.country_code}`}
                                        value={C.Country.country_name}
                                      >
                                        {C.Country.country_name}
                                      </option>
                                    )),
                                  ]
                                  : ""}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a country.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col xs={6} md={6}>
                            <Form.Group controlId="sel_state_new">
                              <Form.Label>
                                <b>State</b>
                              </Form.Label>
                              <Form.Select
                                id="sel_state_new_shipping"
                                name="sel_state_new_shipping"
                                value={selstate_shipping}
                                onChange={handleChangeFieldShipping}
                                required
                              >
                                <option value=""> -- Select State -- </option>
                                {State
                                  ? [
                                    State.map((S) => (
                                      <option
                                        key={`state_${S.State.state_name}`}
                                        value={S.State.state_name}
                                      >
                                        {S.State.state_name}
                                      </option>
                                    )),
                                  ]
                                  : ""}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please select a state.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={6} md={6}>
                            <Form.Group>
                              <Form.Label>
                                <b>Pincode</b>
                              </Form.Label>
                              <Form.Control
                                type="number"
                                id="txt_zipcode_new_shipping"
                                name="txt_zipcode_new_shipping"
                                value={zipcode_shipping}
                                onChange={handleChangeFieldShipping}
                                maxLength={6}
                                onKeyDown={(e) => {
                                  if (
                                    e.target.value.length >= 6 &&
                                    e.key !== "Backspace"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Container>
                    </ModalBody>
                    <ModalFooter>
                      <Btn
                        attrBtn={{
                          color: "secondary",
                          onClick: toggleshipping,
                        }}
                      >
                        Close
                      </Btn>
                      <Button color="primary" type="submit">
                        SaveChanges
                      </Button>
                    </ModalFooter>
                  </Form>
                </Modal>

                {/* modal attribute */}
                <Modal
                  isOpen={showattrmodal}
                  toggle={toggleattributemodal}
                  size="xl"
                  backdrop="static"
                  keyboard={false}
                >
                  <ModalHeader
                    toggle={() => {
                      setShowattrmodal(!showattrmodal);
                      setProductselectid("");
                      setSelectedProduct(null);
                    }}
                    className="Modal-addressheader"
                  >
                    Add Attributes for {AttrProductname}
                    {productImage && (
                      <img
                        src={productImage}
                        alt={AttrProductname}
                        className="img-fluid ml-2 ms-2"
                        style={{
                          maxWidth: "50px",
                          maxHeight: "50px",
                          borderRadius: "10px",
                        }}
                      />
                    )}
                  </ModalHeader>
                  <Form onSubmit={handleSubmit(onsubmit)}>
                    <ModalBody>
                      <Row>
                        {pricelist_array.length > 0 ? (
                          <div>
                            <Table striped bordered hover responsive="xl">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Price</th>
                                  {Object.keys(attr_label).length > 0 &&
                                    Object.keys(attr_label).map((key) => (
                                      <th key={key}>
                                        {attr_label[key]?.Label}
                                      </th>
                                    ))}
                                </tr>
                              </thead>
                              <tbody>
                                {pricelist_array.map((item, index) => (
                                  <tr key={index}>
                                    <td
                                      style={{ cursor: "pointer" }}
                                      onClick={() => Saveattributejson(index)}
                                    >
                                      <IoIosAddCircle size={25} />
                                    </td>
                                    <td>{item.price}</td>
                                    {(item.attr_arr ?? []).map((attr, attrIndex) => (
                                      <td
                                        key={attrIndex}
                                        className="text-center"
                                      >
                                        {attr.Value ? attr.Value : "---"}
                                      </td>
                                    ))}
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        ) : (
                          <div>No attribute found</div>
                        )}
                      </Row>
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => {
                          setShowattrmodal(!showattrmodal);
                          setProductselectid("");
                          setSelectedProduct(null);
                          setJson({});
                          setJsonName({});
                        }}
                      >
                        Close
                      </Button>
                    </ModalFooter>
                  </Form>
                </Modal>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Dashboardpos;